import { ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Subscription, firstValueFrom } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { CommonHttpService } from '../../services/common-http.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportType, FilterType, GraphType } from '../../../views/report-details/interfaces/report-details.interface';
import { TalentBenchReportOptions, TeamsAndRolesResponse } from './interfaces/generate-report-form.interface';
import { Severity } from '../../helpers/common-methods';
import { CommonMethods } from '../../helpers/common-methods';
import { SavedReportService } from '../../services/saved-report.service';
import { TimezoneTransformPipe } from '../../pipes/timezone-transform.pipe';
import { toCalendarDate } from '../../helpers/calendar-date.utils';
import { SpinnerService } from '../../services/spinner.service';
import { ReportSecurityComponent } from '../report-security/report-security.component';
interface Option {
  name: any;
  code: any;
  sortOrder?: 'ASC' | 'DESC';
}

@Component({
  selector: 'bi-generate-report-form',
  standalone: false,
  templateUrl: './generate-report-form.component.html',
  styleUrl: './generate-report-form.component.scss'
})
export class GenerateReportFormComponent implements OnInit, OnDestroy {
  @Input() formData: any;
  @Input() reportConfig: any;
  @Input() userConfig: any;
  @Input() dimensionColumnsOptions: any = [];
  @Input() roleWiseUsersList: any = [];
  @Input() teamMembers: any = [];
  @Input() savedReportData: any = {};
  @Input() recordsPerPage: number = 10;
  @Input() stageOptions: Option[] = [];
  @Input() usersListOptionsInput: Option[] = [];

  @Input() teamsAndRolesResponse: TeamsAndRolesResponse = {
    success: 1,
    userRestrictionFields: {},
    teamData: {
      teamNames: [],
      teamMembers: {}
    },
    roles: []
  };

  @Input() talentBenchReportOptions: TalentBenchReportOptions = {
    statuses: [],
    subStatuses: {}
  };

  @Output() reportData = new EventEmitter<any>();
  @Output() reportFormData = new EventEmitter<any>();
  generateReportFormVisible: boolean = false;
  accessibleBusinessUnitList: Option[] = [];
  globalBusinessUnitList: Option[] = [];
  indiaBusinessUnitList: Option[] = [];
  selectedBusinessUnitList: Option[] = [];
  allModulesData: any = [];
  modules: Option[] = [];
  generateReportTitle: string = 'Generate Report';
  popupWidth: string = '80vw';
  chooseColumnsClass: string = 'col-6';
  applyFiltersClass: string = 'col-6';
  saveReportFields: boolean = false;
  reportModuleFields: boolean = true;
  showAllFields: boolean = false;
  showColumnsPopup: boolean = false;
  showFiltersPopup: boolean = false;
  reportForm: FormGroup;
  reportTypes: Option[] = [];
  allColumns: Option[] = [];
  allColumnsData: any = [];
  allFilters: Option[] = [];
  groupByFilters: Option[] = [];
  dimensionColumns: Option[] = [];
  groupByColumns: Option[] = [];
  dateTypeFilters: Option[] = [];
  preDefinedFilterOptions: Option[] = [];
  periodValues: Option[] = [];
  automationPeriodValues: Option[] = [];
  sortColumns: Option[] = [];
  columnTypeFilters: any = [];
  tempColumnTypeFilters: any = [];
  tempFilterDropdownOptions: any = [];
  deletedFilterIds: any = [];
  defaultDateFormat: any = "mm.dd.yy";
  loggedInUserTimeZone: any = '';
  defaultTimeZone: any = '';
  viewAllAccess: boolean = false;
  disableVal: any = "checked";
  editAllAccess: boolean = false;
  viewAccessCondition: boolean = false;
  stages: Option[] = [];
  usersListOptions: Option[] = [];
  private conversionRatioFieldsPromise: Promise<boolean> | null = null;
  private usersListPromise: Promise<boolean> | null = null;

  groupByLevelOptions: any = [{ 'name': 'Group by first column', 'code': 1 }, { 'name': 'Group by first two columns', 'code': 2 }, { 'name': 'Group by first three columns', 'code': 3 }];

  placementReportOptions: Option[] = [{ 'name': 'All Placements', 'code': 6 }, { 'name': 'Joined', 'code': 1 }, { 'name': 'Terminations', 'code': 2 }, { 'name': 'Confirmations', 'code': 3 }, { 'name': 'Not Joined', 'code': 4 }];
  instanceTypeOptions: Option[] = [{ 'name': 'Global', 'code': 1 }, { 'name': 'India', 'code': 2 }];
  filterType = FilterType;
  ReportType = ReportType;

  currencyList: Option[] = [];
  hideChildModules: boolean = false;
  enableCustomReportApi: boolean = false;

  // Talent Bench Report
  talentBenchActiveStatus: Option[] = [{ 'name': 'Active', 'code': 1 }, { 'name': 'Inactive', 'code': 2 }];

  private formDataSubscription: any;
  private columnsValueChangesSubscription: any;
  editColumn: string = '';
  editingItemCode: string | null = null;
  enableOrderLists: boolean = false; // Keep disabled to avoid PrimeNG issues
  useCustomDisplay: boolean = true; // Use custom display instead of PrimeNG
  reportSecurity: any;
  roleList: any;
  teamList: any;
  isUpdated: boolean = false;
  private _fb: any;
  editTeamList: any;
  editRoleList: any;
  RoleDisabledOpt: boolean = false;
  editRoleDisabled: boolean = false;
  maxEndDate: Date | null = null;
  filterMaxEndDates: { [key: number]: Date } = {};
  filterMinEndDates: { [key: number]: Date } = {};
  checked: boolean = false;

  constructor(
    private _commonService: CommonService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _commonHttpService: CommonHttpService,
    private fb: FormBuilder,
    private router: Router,
    private _commonMethods: CommonMethods,
    private savedReportService: SavedReportService,
    private timezoneTransformPipe: TimezoneTransformPipe,
    private spinnerService: SpinnerService
  ) {
    this.reportForm = this.fb.group({
      reportId: ['', [Validators.required]],
      reportName: [''],
      reportDesc: [''],
      businessUnitIds: [[], [Validators.required]],
      reportType: [ReportType.DETAILED_REPORT, [Validators.required]],
      groupByFilters: [new FormControl({ value: [], disabled: true }, [Validators.required])],
      columns: [[], [Validators.required]],
      sortColumns: [[]],
      filters: this.fb.array([]),
      preDefinedFilters: this.fb.array([]),
      dateFilterCol: [''],
      periodValue: [6, [Validators.required]],
      custStartDate: [''],
      custEndDate: [''],
      dimensionColumnId: [''],
      groupByLevel: [''],
      filterType: [''],
      filterRole: [''],
      teamList: [[]],
      teamMembersList: [[]],
      roleUserIds: [[]],
      placementReportOn: [[6]],
      currencyConversion: [false],
      currencyDetails: [0],
      marketingStatus: [[]],
      benchStatus: [[]],
      benchSubStatus: [[]],
      defaultGraphType: [GraphType.LINE_CHART],
      enableHierarchySecurity: [false],
      // Report security controls
      viewRoleIds: [[]],
      viewTeamIds: [[]],
      editRoleIds: [[]],
      editTeamIds: [[]],
      viewToAll: [this.viewAllAccess],
      // editToAll: [this.editAllAccess],
      editToAll: [{ value: false, disabled: true }],
      instanceType: [1], // 1: Global, 2: India
      includePipelines: [false],
      stages: [[]],
      usersList: [[]],
    });

    // Subscribe to form value changes
    // this._subscription.add(
    //   this.reportForm.valueChanges.subscribe(() => {
    //     this._changeDetectorRef.detectChanges();
    //   })
    // );
    this._commonService.formLoaded = false;
  }

  ngOnInit(): void {
    this.formDataSubscription = this._commonService.generateReportForm.subscribe({
      next: (state: any) => {
        this.hideChildModules = state.hideChildModules;

        this.generateReportFormVisible = state.show;
        if (this.generateReportFormVisible && !this.formData) {
          this.reportForm.reset();
          this.reportForm.get('businessUnitIds')?.setValue(this.selectedBusinessUnitList);
        }

        // Only clean data if form is properly initialized
        if (this.reportForm) {
          this.cleanColumnsData();
        }

        this._changeDetectorRef.detectChanges();
      },
      error: (error) => {
        // Handle subscription error silently
      }
    });

    // Subscribe to defaultGraphType changes
    let defaultGraphTypeSubscription: any = this._commonService.defaultGraphType.subscribe((graphType: any) => {
      if (graphType) {
        this.reportForm.get('defaultGraphType')?.setValue(graphType);
      }
    });

    // Subscribe to periodValue changes to update custStartDate and custEndDate validation
    this.reportForm.get('periodValue')?.valueChanges.subscribe((value) => {
      this.updateReportFilterValidation();
    });

    this.columnsValueChangesSubscription = this.reportForm.get('columns')?.valueChanges.subscribe(() => {
      this.syncGraphTypeWithColumns(false);
    });
  }
  async ngBeforeViewInit() {
    if (this.formData) {
      await this.getReportConfig({ value: this.formData.reportId });
    }
  }

  ngOnViewInit() {
    if (!this.userConfig) {
      this._commonHttpService.getUserConfig().subscribe((userConfig: any) => {
        this.userConfig = userConfig;
        this.setUserConfig();
      });
    } else {
      this.setUserConfig();
    }
  }

  async setUserConfig() {
    if (!this._commonService.formLoaded) {
      this.defaultDateFormat = this.userConfig.dateFormat;
      this.loggedInUserTimeZone = this.userConfig.loggedInUserTimeZone;
      this.defaultTimeZone = this.userConfig.defaultTimeZone;
      this.currencyList = this.userConfig.currencyList;
      this.enableCustomReportApi = this.userConfig.enableCustomReportApi;
      this._commonService.formLoaded = true;
      this.accessibleBusinessUnitList = this.userConfig.userBusinessUnitDetails.accessibleBusinessUnitList;
      this.selectedBusinessUnitList = this.userConfig.userBusinessUnitDetails.visibleBusinessUnitList ? this.userConfig.userBusinessUnitDetails.visibleBusinessUnitList : [];
      this.globalBusinessUnitList = this.userConfig.userBusinessUnitDetails.globalBusinessUnitList;
      this.indiaBusinessUnitList = this.userConfig.userBusinessUnitDetails.indiaBusinessUnitList;
      this.columnTypeFilters = this.userConfig.columnTypeFilters;
      this.periodValues = [{ name: 'Select', code: '18' }, ...this.userConfig.periodValues];
      this.automationPeriodValues = this.userConfig.automationPeriodValues;
      if (!this.formData?.businessUnitIds?.length) {
        this.reportForm.get('businessUnitIds')?.patchValue(this.selectedBusinessUnitList);
      }
      this.reportForm.get('instanceType')?.setValue(Number(this.userConfig.userBusinessUnitDetails.defaultInstanceType));
      await this.setAllModulesData();
      await this.setModules();
      if (!this.formData) {
        this.showColumnsPopup = true;
        this.showFiltersPopup = true;
        this.popupWidth = '80vw';
        this.chooseColumnsClass = 'col-6';
        this.applyFiltersClass = 'col-6';
      }
    }

    // Always load report config / stage columns when form opens with a report
    if (this.formData?.reportId) {
      await this.getReportConfig({ value: this.formData.reportId });
    }
  }

  getAccessibleBusinessUnitList() {
    if (this.reportForm.get('reportId')?.value == '20') {
      if (Number(this.reportForm.get('instanceType')?.value) == 1) {
        return [...this.globalBusinessUnitList];
      } else {
        return [...this.indiaBusinessUnitList];
      }
    }
    return [...this.accessibleBusinessUnitList, { name: 'Organization', code: '0' }];
  }

  showAllFormFields() {
    this.showAllFields = true;
    this.saveReportFields = true;
    this.reportModuleFields = true;
    this.showColumnsPopup = true;
    this.showFiltersPopup = true;
    this.popupWidth = '80vw';
    this.chooseColumnsClass = 'col-4';
    this.applyFiltersClass = 'col-4';
    this.generateReportTitle = 'Save Report';
    // Load roles and teams data when showing save report fields
    this.loadRolesAndTeamsData();
  }

  showColumnsFormFields() {
    this.showAllFields = false;
    this.saveReportFields = false;
    this.reportModuleFields = false;
    this.showColumnsPopup = true;
    this.showFiltersPopup = false;
    this.generateReportTitle = 'Edit Columns';
    this.popupWidth = '40vw';
    this.chooseColumnsClass = 'col-12';
    this.applyFiltersClass = 'col-12';
    this.syncSavedBusinessUnitIds();
    void this.refreshTeamsAndRolesIfNeeded();
  }

  showFiltersFormFields() {
    this.showAllFields = false;
    this.saveReportFields = false;
    this.reportModuleFields = false;
    this.showColumnsPopup = false;
    this.showFiltersPopup = true;
    this.generateReportTitle = 'Edit Filters';
    this.popupWidth = '40vw';
    this.chooseColumnsClass = 'col-12';
    this.applyFiltersClass = 'col-12';
    this.syncSavedBusinessUnitIds();
    void this.refreshTeamsAndRolesIfNeeded();
  }

  /* hideGenerateReportForm() {
    // Emit current form data before hiding the form
    this.emitCurrentFormData();
    
    this._commonService.hideGenerateReportForm();
    this.generateReportFormVisible = false;
    this._changeDetectorRef.detectChanges();
  } */

  hideGenerateReportForm() {
    // ❌ REMOVE DATA EMISSION - Only emit on submit
    // this.emitCurrentFormData(); // Comment out this line

    this._commonService.hideGenerateReportForm();
    this.generateReportFormVisible = false;
    this._changeDetectorRef.detectChanges();
  }

  /**
   * Emit current form data to parent component when form is hidden/cancelled
   */
  /* emitCurrentFormData() {
    if (this.reportForm && this.reportForm.value) {
      const formData = {
        reportFormData: this.reportForm.value,
        reportConfig: this.reportConfig,
        userConfig: this.userConfig,
        teamsAndRolesResponse: this.teamsAndRolesResponse,
        dimensionColumnsOptions: this.dimensionColumnsOptions,
        talentBenchReportOptions: this.talentBenchReportOptions,
        savedReportData: this.savedReportData,
        actionType: 'formHidden'
      };
      
      this.reportData.emit(formData);
    }
  } */


  emitCurrentFormData() {
    // ❌ REMOVE DATA EMISSION - Only emit on submit, not on form hide

    // Comment out or remove the emission code:
    /*
    if (this.reportForm && this.reportForm.value) {
        const formData = {
            reportFormData: this.reportForm.value,
            reportConfig: this.reportConfig,
            userConfig: this.userConfig,
            teamsAndRolesResponse: this.teamsAndRolesResponse,
            dimensionColumnsOptions: this.dimensionColumnsOptions,
            talentBenchReportOptions: this.talentBenchReportOptions,
            savedReportData: this.savedReportData,
            actionType: 'formHidden'
        };
        
        this.reportData.emit(formData);
    }
    */
  }

  checkFormDirty() {
    if (this.reportForm) {
      this.reportForm.markAsDirty();
      Object.values(this.reportForm.controls).forEach(control => {
        control.markAsDirty();
      });
    }
  }

  async generateReport() {

  }

  /* async onSubmit() {
    this.reportForm.get('reportName')?.removeValidators(Validators.required);
    this.reportForm.get('reportDesc')?.removeValidators(Validators.required);
    this.reportForm.get('reportName')?.updateValueAndValidity();
    this.reportForm.get('reportDesc')?.updateValueAndValidity();
    this.reportForm.markAllAsTouched();
    this.checkFormDirty();
    this.updateReportFilterValidation();
    
    // Log individual control errors
    Object.keys(this.reportForm.controls).forEach(key => {
      const control = this.reportForm.get(key);
      if (control && control.errors) {
      }
    });
    
    // Log form array errors
    const filtersArray = this.reportForm.get('filters') as FormArray;
    if (filtersArray) {
      filtersArray.controls.forEach((control, index) => {
        if (control.errors) {
        }
      });
    }
    if (this.reportForm.valid) {
      if (this.reportForm.get('reportId')?.value != '' && this.reportForm.get('reportId')?.value != null && await this.validateReportForm()) {
        this.reportFormData = this.reportForm.value;
        // Check if we're already in report-details route
        if (this.router.url.includes('/report-details')) {
          // Emit the data to parent component
          this.reportData.emit({ reportFormData: this.reportFormData, reportConfig: this.reportConfig, userConfig: this.userConfig, teamsAndRolesResponse: this.teamsAndRolesResponse, dimensionColumnsOptions: this.dimensionColumnsOptions, talentBenchReportOptions: this.talentBenchReportOptions, savedReportData: this.savedReportData});
        } else {
          // Navigate to report-details with the data
          this.router.navigate(['/report-details/' + this.reportForm.get('reportId')?.value + '/0'], {
            state: { reportFormData: this.reportFormData, reportConfig: this.reportConfig, userConfig: this.userConfig, dimensionColumnsOptions: this.dimensionColumnsOptions, teamsAndRolesResponse: this.teamsAndRolesResponse, talentBenchReportOptions: this.talentBenchReportOptions, savedReportData: this.savedReportData }
          });
        }

        this.hideGenerateReportForm();
      } else {
        // Form is invalid - cannot submit
      }
    }
  } */

  async onSubmit() {
    this.reportForm.get('reportName')?.removeValidators(Validators.required);
    this.reportForm.get('reportDesc')?.removeValidators(Validators.required);
    this.reportForm.get('viewRoleIds')?.removeValidators(Validators.required);
    this.reportForm.get('reportName')?.updateValueAndValidity();
    this.reportForm.get('reportDesc')?.updateValueAndValidity();
    this.reportForm.get('viewRoleIds')?.updateValueAndValidity();
    this.reportForm.markAllAsTouched();
    this.checkFormDirty();
    this.updateReportFilterValidation();
    /**
     * @author: pavan,v
     * @description: Validate column and group by configuration BEFORE submission start
     */
    // Validate column and group by configuration BEFORE submission
    const selectedColumns = this.reportForm.get('columns')?.value || [];
    const groupByFilters = this.reportForm.get('groupByFilters')?.value || [];
    
    // Helper function to convert number to text
    const numberToText = (num: number): string => {
      const numberWords: { [key: number]: string } = {
        1: 'one', 2: 'two', 3: 'three'
      };
      return numberWords[num] || num.toString();
    };
    
    // Check for Summary/Graph reports: columns must be >= groupByFilters
    if (groupByFilters.length > 0 && this.reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT) {
      const requiredColumns = groupByFilters.length; // Need at least one more column than group by
      if (selectedColumns.length < requiredColumns) {
        const columnText = groupByFilters.length === 1 ? 'column' : 'columns';
        const numberText = numberToText(groupByFilters.length);
        const groupByText = groupByFilters.length === 1 ? 'first column' : 'first ' + numberText + ' columns';
        this._commonMethods.showToastMessage(
          'Please select minimum ' + numberText + ' ' + requiredColumns + ' to Group By ' + groupByText + '.',
          'Validation Error',
          Severity.error
        );
        return; // Stop submission
      }
    }
    
    /** 
    * @author: pavan.v
    * @description: Validate column and group by configuration BEFORE submission end
    */

    if (this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT) {
      this.syncGraphTypeWithColumns(false);
      const columnsCount = selectedColumns.length;
      const graphType = this.reportForm.get('defaultGraphType')?.value;
      if (
        columnsCount > 0 &&
        graphType &&
        !this._commonService.isGraphTypeAllowedForColumns(graphType, columnsCount)
      ) {
        this._commonMethods.showToastMessage(
          'The selected graph type is not supported with multiple Y-Axis columns. Please choose a multi-series graph type (e.g. Line, Stacked Column, Clustered Column).',
          'Validation Error',
          Severity.error
        );
        return;
      }
    }

    this._commonService.defaultGraphType = (this.reportForm.get('defaultGraphType')?.value) ? this.reportForm.get('defaultGraphType')?.value : '';
    // Log individual control errors
    Object.keys(this.reportForm.controls).forEach(key => {
      const control = this.reportForm.get(key);
      if (control && control.errors) {
      }
    });

    // Log form array errors
    const filtersArray = this.reportForm.get('filters') as FormArray;
    if (filtersArray) {
      filtersArray.controls.forEach((control, index) => {
        if (control.errors) {
        }
      });
    }
    this.validateReportForm()
    if (this.reportForm.valid) {
      this.editingItemCode = null;
      if (this.reportForm.get('reportId')?.value != '' && this.reportForm.get('reportId')?.value != null && await this.validateReportForm()) {
        const reportFormPayload: any = { ...this.reportForm.value };
        // Backend expects numeric dateFilterCol (0 when none); never send ""
        if (reportFormPayload.dateFilterCol === '' || reportFormPayload.dateFilterCol == null) {
          reportFormPayload.dateFilterCol = 0;
        }

        // ✅ DATA EMISSION ONLY HAPPENS HERE
        if (this.router.url.includes('/report-details')) {
          // Emit the data to parent component
          this.reportData.emit({
            reportFormData: reportFormPayload,
            reportConfig: this.reportConfig,
            userConfig: this.userConfig,
            teamsAndRolesResponse: this.teamsAndRolesResponse,
            dimensionColumnsOptions: this.dimensionColumnsOptions,
            talentBenchReportOptions: this.talentBenchReportOptions,
            savedReportData: this.savedReportData
          });
        } else {
          // Navigate to report-details with the data
          this.router.navigate(['/report-details/' + this.reportForm.get('reportId')?.value + '/0'], {
            state: {
              reportFormData: reportFormPayload,
              reportConfig: this.reportConfig,
              userConfig: this.userConfig,
              dimensionColumnsOptions: this.dimensionColumnsOptions,
              teamsAndRolesResponse: this.teamsAndRolesResponse,
              talentBenchReportOptions: this.talentBenchReportOptions,
              savedReportData: this.savedReportData
            }
          });
        }

        this.hideGenerateReportForm();
      } else {
        // Form is invalid - cannot submit
      }
    }
  }

  async validateReportForm(): Promise<boolean> {
    if (this.reportForm.value.reportId == '') {
      return new Promise<boolean>((resolve) => {
        resolve(true);
      });
    } else {
      let popupDisplay = false;
      return new Promise<boolean>((resolve) => {
        /** 
         * @author: pavan.v
         * @description: Validate column and group by columns configuration
        */
        // Validate: Check if columns are sufficient for grouping
        const selectedColumns = this.reportForm.get('columns')?.value || [];
        const groupByFilters = this.reportForm.get('groupByFilters')?.value || [];
        
        // Helper function to convert number to text
        const numberToText = (num: number): string => {
          const numberWords: { [key: number]: string } = {
            1: 'one', 2: 'two', 3: 'three'
          };
          return numberWords[num] || num.toString();
        };
        
        // Prevent internal server error: Columns must be >= group by
        // Check for Summary/Graph reports
        if (groupByFilters.length > 0 && this.reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT) {
          const requiredColumns = groupByFilters.length;
          if (selectedColumns.length < requiredColumns) {
            const columnText = groupByFilters.length === 1 ? 'column' : 'columns';
            const numberText = numberToText(groupByFilters.length);
            const groupByText = groupByFilters.length === 1 ? 'first column' : 'first ' + numberText + ' columns';
            this._commonMethods.showToastMessage(
              'Please select minimum ' + numberText + ' ' + groupByFilters.length + ' to Group By ' + groupByText + '.',
              'Validation Error',
              Severity.error
            );
            resolve(false);
            return;
          }
        }
        
        /**
         * @author: pavan.v
         * @description: Validate group by filters configuration  end
         */

        if (this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT) {
          this.syncGraphTypeWithColumns(false);
          const columnsCount = selectedColumns.length;
          const graphType = this.reportForm.get('defaultGraphType')?.value;
          if (
            columnsCount > 0 &&
            graphType &&
            !this._commonService.isGraphTypeAllowedForColumns(graphType, columnsCount)
          ) {
            this._commonMethods.showToastMessage(
              'The selected graph type is not supported with multiple Y-Axis columns. Please choose a multi-series graph type (e.g. Line, Stacked Column, Clustered Column).',
              'Validation Error',
              Severity.error
            );
            resolve(false);
            return;
          }
        }

        // Check form arrays specifically
        const filtersArray = this.reportForm.get('filters') as FormArray;
        const preDefinedFiltersArray = this.reportForm.get('preDefinedFilters') as FormArray;

        // Check each filter in the filters array
        for (let i = 0; i < filtersArray.length; i++) {
          const filterControl = filtersArray.at(i);
          let tempDataType = Number(filterControl.get('dataType')?.value);
          filterControl.get('value')?.removeValidators(Validators.required);
          filterControl.get('startDate')?.removeValidators(Validators.required);
          filterControl.get('endDate')?.removeValidators(Validators.required);
          if (tempDataType != 3 && tempDataType != 4 && tempDataType != 13 && tempDataType != 14 && tempDataType < 17) {
            filterControl.get('value')?.addValidators(Validators.required);
          } else {
            filterControl.get('value')?.removeValidators(Validators.required);
          }
          if (tempDataType == 13 || tempDataType == 14) {
            filterControl.get('startDate')?.addValidators(Validators.required);
            filterControl.get('endDate')?.addValidators(Validators.required);
          }

          filterControl.get('value')?.updateValueAndValidity();
          filterControl.get('startDate')?.updateValueAndValidity();
          filterControl.get('endDate')?.updateValueAndValidity();

          // Mark all sub-fields as dirty
          filterControl.get('value')?.markAsDirty();
          filterControl.get('startDate')?.markAsDirty();
          filterControl.get('endDate')?.markAsDirty();
          filterControl.get('columnId')?.markAsDirty();
          filterControl.get('dataType')?.markAsDirty();
          filterControl.get('options')?.markAsDirty();
          if (i > 0) {
            filterControl.get('filterCondition' + i)?.markAsDirty();
          }
        }

        let columnLevelControls = ['columns', 'groupByFilters', 'groupByLevel', 'filterType', 'filterRole', 'teamList', 'teamMembersList', 'roleUserIds', 'dimensionColumnId'];
        // Check each form control for validation errors
        Object.keys(this.reportForm.controls).forEach(key => {
          const control = this.reportForm.get(key);
          if (control) {
            // Check if required field is empty
            if (control.hasValidator(Validators.required) && ((!control.value && control.value != 0) || (Array.isArray(control.value) && control.value.length === 0))) {
              if (columnLevelControls.includes(key) && !popupDisplay && !this.showAllFields && !this.reportModuleFields) {
                this.showColumnsFormFields();
                this._commonService.showGenerateReportForm();
                popupDisplay = true;
              }
              else if (key == 'periodValue' && !popupDisplay && !this.showAllFields && !this.reportModuleFields) {
                this.showFiltersFormFields();
                this._commonService.showGenerateReportForm();
                popupDisplay = true;
              }
            } else {
              if (key == 'filters' && !popupDisplay && !this.showAllFields && !this.reportModuleFields) {
                // Log form array errors
                const filtersArray = this.reportForm.get(key) as FormArray;
                if (!filtersArray.valid) {
                  filtersArray.controls.forEach((control, index) => {
                    if (control instanceof FormGroup) {
                      Object.keys(control.controls).forEach((key, subIndex) => {
                        const subControl = control.get(key);
                        if (subControl?.errors) {
                        }
                      });
                    }
                  });
                  this.showFiltersFormFields();
                  this._commonService.showGenerateReportForm();
                  popupDisplay = true;
                }
              }
            }

            // Check for validation errors
            if (control.errors) {
              // Validation error in control
            }
          }
        });
        this.checkFormDirty();
        resolve(this.reportForm.valid);
      });
    }
  }

  async getReportConfig($event: any): Promise<void> {
    if (!$event?.value && $event?.value !== 0) {
      return;
    }

    const reportId = Number($event.value);
    if (reportId === 5) {
      await this.getTalentBenchReportOptions();
    }

    const configMatchesReport = this.reportConfig && Number(this.reportConfig.id) === reportId;
    if (!configMatchesReport) {
      try {
        this.reportConfig = await firstValueFrom(
          this._commonHttpService.getReportConfig({
            reportId,
            reportType: this.reportForm.get('reportType')?.value as ReportType,
            instanceType: this.reportForm.get('instanceType')?.value
          })
        );
      } catch {
        return;
      }
    }

    // After get-report-config: load stage columns for report 109/110 (await so form has values)
    if (reportId === 109 || reportId === 110) {
      await this.getConversionRatioFields(reportId);
    }

    // Load users list for report 110 only
    if (reportId === 110) {
      await this.getUsersListOptions(undefined, reportId);
    }

    try {
      await this.setReportConfig();
    } catch {
      // Continue even if column/filter setup fails
    }

    // Retry users load after form/BUs are fully patched
    if (reportId === 110 && !this.usersListOptions?.length) {
      this.usersListPromise = null;
      await this.getUsersListOptions(undefined, reportId);
    }
  }

  private syncSavedBusinessUnitIds(): void {
    if (!this.formData?.businessUnitIds?.length) {
      return;
    }

    const formBusinessUnitIds = this.reportForm.get('businessUnitIds')?.value || [];
    const shouldSyncSavedBusinessUnits = formBusinessUnitIds.length === 0 ||
      this.areBusinessUnitIdsEqual(formBusinessUnitIds, this.selectedBusinessUnitList);

    if (shouldSyncSavedBusinessUnits) {
      this.reportForm.get('businessUnitIds')?.patchValue(this.formData.businessUnitIds, { emitEvent: false });
    }
  }

  private areBusinessUnitIdsEqual(first: any[], second: any[]): boolean {
    if (!Array.isArray(first) || !Array.isArray(second) || first.length !== second.length) {
      return false;
    }

    const normalize = (ids: any[]) => [...ids].map((id) => String(id)).sort();
    const normalizedFirst = normalize(first);
    const normalizedSecond = normalize(second);

    return normalizedFirst.every((id, index) => id === normalizedSecond[index]);
  }

  private normalizeBusinessUnitIds(ids?: any[]): any[] {
    if (!Array.isArray(ids) || ids.length === 0) {
      return [];
    }
    return ids
      .map((id: any) => (id != null && typeof id === 'object' ? id.code : id))
      .filter((id: any) => id != null && id !== '' && !isNaN(Number(id)));
  }

  private resolveBusinessUnitIds(businessUnitIds?: any[]): any[] {
    const fromParam = this.normalizeBusinessUnitIds(businessUnitIds);
    if (fromParam.length > 0) {
      return fromParam;
    }

    const fromForm = this.normalizeBusinessUnitIds(this.reportForm.get('businessUnitIds')?.value);
    if (fromForm.length > 0) {
      return fromForm;
    }

    const fromFormData = this.normalizeBusinessUnitIds(this.formData?.businessUnitIds);
    if (fromFormData.length > 0) {
      return fromFormData;
    }

    return this.normalizeBusinessUnitIds(this.selectedBusinessUnitList);
  }

  private async refreshTeamsAndRolesIfNeeded(): Promise<void> {
    const reportId = Number(this.reportForm.get('reportId')?.value);
    if (![9, 14, 16, 36].includes(reportId)) {
      return;
    }

    await this.getRoleTeamsList();
    this._changeDetectorRef.detectChanges();
  }

  async getRoleTeamsList(businessUnitIds?: any[]) {
    return new Promise<boolean>((resolve) => {
      const resolvedBusinessUnitIds = this.resolveBusinessUnitIds(businessUnitIds);
      if (!resolvedBusinessUnitIds?.length) {
        resolve(false);
        return;
      }

      this._commonHttpService.getRoleWiseUsersList(resolvedBusinessUnitIds).subscribe((response: TeamsAndRolesResponse) => {
        this.teamsAndRolesResponse = response;
        resolve(true);
      });
    });
  }

  async onBusinessUnitIdsChange(event?: any): Promise<void> {
    const reportId = Number(this.reportForm.get('reportId')?.value || this.formData?.reportId);
    // Use only the newly selected values — do not fall back to saved/default BUs
    const businessUnitIds = this.normalizeBusinessUnitIds(
      event?.value ?? this.reportForm.get('businessUnitIds')?.value
    );

    this.reportForm.get('businessUnitIds')?.setValue(businessUnitIds, { emitEvent: false });
    if (this.formData) {
      this.formData.businessUnitIds = businessUnitIds;
    }

    if (reportId === 110) {
      this.usersListPromise = null;
      await this.getUsersListOptions(businessUnitIds);
      this._changeDetectorRef.detectChanges();
      return;
    }

    if (![9, 14, 16, 36].includes(reportId)) {
      return;
    }

    if (!businessUnitIds?.length) {
      return;
    }

    await this.getRoleTeamsList(businessUnitIds);
    this.resetTeamAndRoleFieldsAfterTeamDataChange(reportId);
    this._changeDetectorRef.detectChanges();
  }

  private resetTeamAndRoleFieldsAfterTeamDataChange(reportId: number): void {
    const hasTeams = (this.teamsAndRolesResponse.teamData?.teamNames || []).length > 0;
    const filterType = Number(this.reportForm.get('filterType')?.value);

    this.reportForm.get('teamList')?.setValue([]);
    this.reportForm.get('teamMembersList')?.setValue([]);
    this.reportForm.get('roleUserIds')?.setValue([]);

    if (reportId === 9) {
      if (filterType === this.filterType.TEAM && !hasTeams) {
        this.reportForm.get('filterType')?.setValue(this.filterType.ROLE);
      }

      const filterRole = this.reportForm.get('filterRole')?.value;
      const roleExists = this.teamsAndRolesResponse.roles?.some((role) => role.code == filterRole);
      if (!roleExists) {
        this.reportForm.get('filterRole')?.setValue(null);
      }

      this.reportForm.get('columns')?.setValue([]);
    }

    void this.updateReportFilterValidation().then(() => {
      ['filterRole', 'roleUserIds', 'teamList', 'teamMembersList'].forEach((controlName) => {
        const control = this.reportForm.get(controlName);
        control?.markAsTouched();
        control?.markAsDirty();
        control?.updateValueAndValidity({ emitEvent: false });
      });
      this._changeDetectorRef.detectChanges();
    });
  }

  private getSelectedTeamMemberCodes(teamIds: any[]): any[] {
    const teamMemberCodes: any[] = [];

    teamIds.forEach((teamId: any) => {
      const teamMembersArray = this.teamsAndRolesResponse.teamData?.teamMembers?.[Number(teamId)];
      if (!teamMembersArray || !Array.isArray(teamMembersArray)) {
        return;
      }

      teamMembersArray.forEach((member: any) => {
        if (!teamMemberCodes.includes(member.code)) {
          teamMemberCodes.push(member.code);
        }
      });
    });

    return teamMemberCodes;
  }

  async getTalentBenchReportOptions(): Promise<boolean> {
    let promise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getTalentBenchReportOptions().subscribe((response: TalentBenchReportOptions) => {
        this.talentBenchReportOptions = response;
        resolve(true);
      });
    });
    return promise;
  }

  async getConversionRatioFields(reportIdParam?: number | string): Promise<boolean> {
    const reportId = Number(
      reportIdParam ?? this.reportForm.get('reportId')?.value ?? this.formData?.reportId ?? 109
    );
    if (reportId !== 109 && reportId !== 110) {
      return false;
    }

    // Prefer options already loaded by report-details — skip API
    if (Array.isArray(this.stageOptions) && this.stageOptions.length > 0) {
      this.stages = this.stageOptions.map((item: any) => ({ code: item.code, name: item.name }));
      this.applySelectedStagesToForm();
      return true;
    }

    // Already loaded — do not call API again
    if (this.stages?.length) {
      this.applySelectedStagesToForm();
      return true;
    }

    // Reuse in-flight request so concurrent callers don't trigger multiple APIs
    if (this.conversionRatioFieldsPromise) {
      return this.conversionRatioFieldsPromise;
    }

    this.conversionRatioFieldsPromise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getConversionRatioField().subscribe({
        next: (response: any) => {
          const options = Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : Array.isArray(response?.options)
                ? response.options
                : [];
          this.stages = options
            .filter((item: any) => item?.code != null && item?.name != null)
            .map((item: any) => ({ code: item.code, name: item.name }));

          this.applySelectedStagesToForm();
          this._changeDetectorRef.detectChanges();
          resolve(true);
        },
        error: () => {
          this.stages = [];
          this.reportForm.get('stages')?.setValue([]);
          this.conversionRatioFieldsPromise = null;
          resolve(false);
        }
      });
    });

    return this.conversionRatioFieldsPromise;
  }

  async getUsersListOptions(
    businessUnitIdsParam?: any[],
    reportIdParam?: number | string
  ): Promise<boolean> {
    const reportId = Number(
      reportIdParam || this.reportForm.get('reportId')?.value || this.formData?.reportId
    );
    if (reportId !== 110) {
      return false;
    }

    const businessUnitIds = this.resolveBusinessUnitIds(businessUnitIdsParam);
    if (!businessUnitIds?.length) {
      this.usersListOptions = [];
      this.reportForm.get('usersList')?.setValue([]);
      return false;
    }

    // Prefer options already loaded by report-details on initial open
    if (
      !businessUnitIdsParam &&
      Array.isArray(this.usersListOptionsInput) &&
      this.usersListOptionsInput.length > 0 &&
      !this.usersListOptions?.length
    ) {
      this.usersListOptions = this.usersListOptionsInput.map((item: any) => ({
        code: item.code,
        name: item.name
      }));
      this.applySelectedUsersToForm();
      this._changeDetectorRef.detectChanges();
      return true;
    }

    // Already loaded for this form session and not a forced BU refresh
    if (!businessUnitIdsParam && this.usersListOptions?.length) {
      this.applySelectedUsersToForm();
      return true;
    }

    // Reuse in-flight request so concurrent callers don't trigger multiple APIs
    if (this.usersListPromise) {
      return this.usersListPromise;
    }

    this.usersListPromise = new Promise<boolean>((resolve) => {
      this._commonHttpService.getUsersList(businessUnitIds).subscribe({
        next: (response: any) => {
          const options = Array.isArray(response)
            ? response
            : Array.isArray(response?.data)
              ? response.data
              : [];
          this.usersListOptions = options
            .filter((item: any) => item?.code != null && item?.name != null)
            .map((item: any) => ({ code: item.code, name: item.name }));

          this.applySelectedUsersToForm();
          this._changeDetectorRef.detectChanges();
          this.usersListPromise = null;
          resolve(true);
        },
        error: () => {
          this.usersListOptions = [];
          this.reportForm.get('usersList')?.setValue([]);
          this.usersListPromise = null;
          resolve(false);
        }
      });
    });

    return this.usersListPromise;
  }

  private explodeCsvOrArray(value: any): any[] {
    if (Array.isArray(value)) {
      return value.map((item: any) => String(item).trim()).filter((item: string) => item !== '');
    }
    if (value === undefined || value === null || value === '') {
      return [];
    }
    return String(value).split(',').map((item: string) => item.trim()).filter((item: string) => item !== '');
  }

  private applySelectedStagesToForm(): void {
    const defaultStages = this.stages.slice(0, 10).map((stage) => stage.code);
    // Prefer form stages array; fall back to API stageIds CSV
    const savedStages = this.explodeCsvOrArray(this.formData?.stages ?? this.formData?.stageIds);
    if (savedStages.length > 0) {
      // Preserve exploded order and map to option codes for selection match
      const orderedSavedStages = savedStages
        .map((code: any) => this.stages.find((stage) => String(stage.code) === String(code))?.code)
        .filter((code: any) => code != null);
      this.reportForm.get('stages')?.setValue(
        orderedSavedStages.length > 0 ? orderedSavedStages : defaultStages
      );
      return;
    }

    if (!this.reportForm.get('stages')?.value?.length) {
      this.reportForm.get('stages')?.setValue(defaultStages);
    }
  }

  private applySelectedUsersToForm(): void {
    const defaultUsers = this.usersListOptions.slice(0, 10).map((user) => user.code);
    // Prefer form usersList array; fall back to API userIds CSV
    const savedUsers = this.explodeCsvOrArray(this.formData?.usersList ?? this.formData?.userIds);
    const currentUsers = this.reportForm.get('usersList')?.value;

    if (savedUsers.length > 0) {
      const orderedSavedUsers = savedUsers
        .map((code: any) => this.usersListOptions.find((user) => String(user.code) === String(code))?.code)
        .filter((code: any) => code != null);
      this.reportForm.get('usersList')?.setValue(
        orderedSavedUsers.length > 0 ? orderedSavedUsers : defaultUsers
      );
      return;
    }

    if (Array.isArray(currentUsers) && currentUsers.length > 0) {
      const filteredUsers = currentUsers
        .map((code: any) => this.usersListOptions.find((user) => String(user.code) === String(code))?.code)
        .filter((code: any) => code != null);
      this.reportForm.get('usersList')?.setValue(
        filteredUsers.length > 0 ? filteredUsers : defaultUsers
      );
      return;
    }

    this.reportForm.get('usersList')?.setValue(defaultUsers);
  }

  async setReportConfig() {

    this.reportForm.get('reportId')?.patchValue(this.reportConfig.id);

    // Step 1: Set all report columns first (this is the foundation)
    await this.setAllReportColumns();

    // Step 2: Set report columns (depends on allColumnsData)
    await this.setReportColumns();

    // Step 3: Set report filters (depends on allColumnsData)
    await this.setReportFilters();

    // Step 3.1: Set report dimension columns (depends on allColumnsData)
    await this.setDimensionColumns();

    // Step 4: Set report group by filters (depends on allColumnsData)
    await this.setReportGroupByFilters();

    // Step 5: Set report group by columns (depends on allColumnsData)
    await this.setReportGroupByColumns();

    // Step 6: Set predefined filters (independent)
    await this.setPredefinedFilters();

    // Step 7: Set date type filters (depends on allColumnsData)
    await this.setDateTypeFilters();

    // Step 8: Set sort columns (depends on allColumnsData)
    await this.setSortColumns();


    // Step 9: Set report ID
    this.reportForm.get('reportId')?.setValue(this.reportConfig.id);

    // Step 10: Patch report form (should be last)
    if (this.formData) {
      await this.patchReportForm();
      if (this.dateTypeFilters.length > 0 && this.reportForm.get('dateFilterCol')?.value == '') {
        this.reportForm.get('dateFilterCol')?.setValue(this.dateTypeFilters[0].code);
      }
      if (this.periodValues.length > 0 && this.reportForm.get('periodValue')?.value == '') {
        this.reportForm.get('periodValue')?.setValue(6); // Since 30 Days are default
      }
    } else {
      //this.reportTypeChanged(this.reportForm.get('reportType')?.value);
      this.setDefaultValues();
    }

    await this.refreshTeamsAndRolesIfNeeded();
  }

  async patchReportForm() {
    return new Promise<void>((resolve) => {
      this.reportForm.get('reportId')?.patchValue(this.formData.reportId);
      this.reportForm.get('groupByLevel')?.patchValue(this.formData.groupByLevel);
      this.setReportTypes({ value: this.formData.reportId });
      // Patching can run more than once for the same form instance. Without
      // resetting first, the saved filters are appended again and every extra
      // copy is written to saved_report_filters on the next save.
      this.filtersFormArray.clear();
      this.tempColumnTypeFilters = [];
      this.tempFilterDropdownOptions = [];
      if (this.formData.filters && this.formData.filters.length > 0) {
        for (let index = 0; index < this.formData.filters.length; index++) {
          let temp_data = this.formData.filters[index];
          this.tempColumnTypeFilters[index] = this.columnTypeFilters[this.getColumnInfo(temp_data.columnId).colDataType];
          this.tempFilterDropdownOptions[index] = temp_data.options;
          this.filtersFormArray.push(this.addFilter(temp_data, index));
        }
      }
      if (this.formData.sortColumns && this.formData.sortColumns.length > 0) {
        this.sortColumns = this.sortColumns.map(column => {
          const matchingColumn = this.formData.sortColumns.find((item: any) => item.code === column.code);
          if (matchingColumn) {
            return {
              ...column,
              sortOrder: matchingColumn.sortOrder || 'ASC'
            };
          }
          return column;
        });
      }
      if (this.formData.periodValue == 10) {
        this.formData.custStartDate = toCalendarDate(this.formData.custStartDate);
        this.formData.custEndDate = toCalendarDate(this.formData.custEndDate);
      }
      if (this.formData.includePipelines !== undefined && this.formData.includePipelines !== null) {
        this.formData.includePipelines = Number(this.formData.includePipelines) === 1 || this.formData.includePipelines === true;
      }
      if (this.formData.enableHierarchySecurity !== undefined && this.formData.enableHierarchySecurity !== null) {
        this.formData.enableHierarchySecurity = Number(this.formData.enableHierarchySecurity) === 1 || this.formData.enableHierarchySecurity === true;
      }
      /** 
       * @author: pavan.v
       * @description: Patch report form value for child reports start
       */
      this.reportForm.patchValue(this.formData);

      if (Number(this.formData.reportType) === ReportType.DIMENSION_REPORT && Array.isArray(this.formData.columns)) {
        const dimensionOptions = this.savedReportService.normalizeDimensionColumnOptions(this.dimensionColumnsOptions);
        const normalizedColumns = this.formData.columns.map((columnId: string | number) =>
          this.savedReportService.resolveDimensionColumnCode(columnId, dimensionOptions)
        );
        this.reportForm.get('columns')?.setValue(normalizedColumns);
      }

      const moduleInfo = this.getModuleInfo(this.formData.reportId);
      if (moduleInfo && moduleInfo.parentId && moduleInfo.parentId !== 0 && moduleInfo.parentId !== null) {
        //this.showAllFields = false;
      }
      // Explicitly set reportType after patchValue to ensure it's displayed
      // Convert to number if it's a string to match the dropdown's optionValue type
      if (this.formData.reportType !== undefined && this.formData.reportType !== null) {
        const reportTypeValue = typeof this.formData.reportType === 'string' 
          ? parseInt(this.formData.reportType) 
          : this.formData.reportType;
        this.reportForm.get('reportType')?.patchValue(reportTypeValue);
        // Check if value exists in reportTypes array
        const exists = this.reportTypes.some(rt => rt.code === reportTypeValue);
      }
      /** 
       * @author: pavan.v
       * @description: Patch report form end
       */
      this.cleanColumnsData();
      this.syncGraphTypeWithColumns(false);
      this._changeDetectorRef.detectChanges();
      resolve();
    });
  }

  async setAllModulesData() {
    return new Promise<void>((resolve) => {
      this.allModulesData = this.userConfig.modules.reduce((acc: any, module: any) => {
        acc[module.id] = module;
        return acc;
      }, {} as Record<string, any>);
      resolve();
    });
  }

  async setModules() {
    return new Promise<void>((resolve) => {
      this.modules = Object.values(this.allModulesData).map((module: any) => ({
        code: module.id,
        name: module.reportName
      }));
      resolve();
    });
  }

  async setAllReportColumns() {
    this.allColumnsData = {};
    return new Promise<void>((resolve) => {
      this.allColumnsData = this.reportConfig.reportColumns.reduce((acc: any, column: any) => {
        acc[column.id] = column;
        return acc;
      }, {} as Record<string, any>);
      this.reportConfig.customFields.forEach((item: any) => {
        this.allColumnsData[item.id] = {
          id: item.id,
          columnName: item.columnName,
          colDataType: item.colDataType,
          searchType: item.searchType,
          existingRecordId: item.existingRecordId,
          listViewFlag: item.listViewFlag,
          forGroupBy: item.forGroupBy,
          forMainFilter: item.forMainFilter,
          customField: item.customField,
        };
      });

      resolve();
    });
  }

  async setReportColumns() {
    return new Promise<void>((resolve) => {
      this.allColumns = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (true) {
            return {
              code: column.id,
              name: column.columnName,
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setReportFilters() {
    return new Promise<void>((resolve) => {
      this.allFilters = Object.values(this.allColumnsData)
        .map((column: any) => {
          //if (column.forMainFilter && column.searchType) {
          if (column.forMainFilter == 1) {
            return {
              code: column.id,
              name: column.columnName,
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setDimensionColumns() {
    return new Promise<void>((resolve) => {
      this.dimensionColumns = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (column.isDimensionField == 1) {
            return {
              code: column.id,
              name: column.columnName,
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setReportGroupByFilters() {
    return new Promise<void>((resolve) => {
      this.groupByFilters = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (column.forGroupBy == 1) {
            return {
              code: column.id,
              name: column.columnName
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setReportGroupByColumns() {
    this.groupByColumns = [];
    return new Promise<void>((resolve) => {
      this.groupByColumns = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (column.forGroupBy == 2) {
            return {
              code: column.id,
              name: column.columnName
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setDateTypeFilters() {
    return new Promise<void>((resolve) => {
      this.dateTypeFilters = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (column.searchType == 2) {
            return {
              code: column.id,
              name: column.columnName
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      if (this.reportForm.get('reportId')?.value == '1') {
        this.dateTypeFilters.push({
          code: 59993,
          name: 'Activity On'
        });
        this.dateTypeFilters.push({
          code: 59994,
          name: 'Rollover On'
        });
        this.dateTypeFilters.push({
          code: 59995,
          name: 'Created OR Modified'
        });
        this.dateTypeFilters.push({
          code: 59996,
          name: 'Placement Created On'
        });
      }
      if (this.reportForm.get('reportId')?.value == '5') {
        this.dateTypeFilters.push({
          code: 59991,
          name: 'Submitted In'
        });
        this.dateTypeFilters.push({
          code: 59992,
          name: 'Submitted Not In'
        });
      }
      console.log(this.reportForm.value)
      if (this.reportForm.get('reportId')?.value == '3') {
        this.dateTypeFilters.push({
          code: 60000,
          name: 'Jobs Created'
        });
        this.dateTypeFilters.push({
          code: 60001,
          name: 'Jobs Not Created'
        });
        this.dateTypeFilters.push({
          code: 60002,
          name: 'Placements Created'
        });
        this.dateTypeFilters.push({
          code: 60003,
          name: 'Placements Not Created'
        });
      }
      console.log('dateTypeFilters', this.dateTypeFilters);
      resolve();
    }); 
  }

  async setSortColumns() {
    return new Promise<void>((resolve) => {
      this.sortColumns = Object.values(this.allColumnsData)
        .map((column: any) => {
          if (column.searchType != 0) {
            return {
              code: column.id,
              name: column.columnName,
              sortOrder: 'ASC',
            }
          }
          return null;
        })
        .filter(Boolean) as Option[];
      resolve();
    });
  }

  async setPredefinedFilters() {
    return new Promise<void>((resolve) => {
      // Initialize form array for predefined filters
      const preDefinedFiltersArray = this.fb.array([]);
      this.preDefinedFilterOptions = [];
      this.reportConfig.reportFilters.forEach((filter: any) => {
      //(this.reportConfig?.reportFilters || []).forEach((filter: any) => {
        this.preDefinedFilterOptions.push({
          code: filter.id,
          name: filter.filterName
        });
        preDefinedFiltersArray.push(this.fb.control([]));
      });
      this.reportForm.setControl('preDefinedFilters', preDefinedFiltersArray);
      resolve();
    });
  }

  setDefaultValues() {
    const dateFilterColControl = this.reportForm.get('dateFilterCol');
    if (this.dateTypeFilters.length > 0) {
      this.reportForm.get('dateFilterCol')?.setValue(this.dateTypeFilters[0].code);
    }
    if (this.periodValues.length > 0) {
      this.reportForm.get('periodValue')?.setValue(6); // Since 30 Days are default
    }
    if (this.reportForm.get('reportId')?.value == '9') {
      this.reportForm.get('filterType')?.setValue(this.filterType.ROLE);
    }
    this.reportForm.get('columns')?.setValue([]);
    if (this.reportForm.get('reportType')?.value == ReportType.DETAILED_REPORT && this.reportForm.get('reportId')?.value != '9' && !this.formData && this.reportForm.get('reportId')?.value != '20') {
      this.reportForm.get('columns')?.setValue(Object.values(this.allColumnsData).slice(0, 20).map((column: any) => { return column.id }));
    } else if (this.reportForm.get('reportType')?.value != ReportType.DIMENSION_REPORT && this.reportForm.get('reportId')?.value != '9' && !this.formData && this.reportForm.get('reportId')?.value != '20') {
      this.reportForm.get('groupByFilters')?.setValue(Object.values(this.allColumnsData).filter((column: any) => column.forGroupBy == 1).slice(0, 1).map((column: any) => { return column.id }));
      this.reportForm.get('columns')?.setValue(Object.values(this.allColumnsData).filter((column: any) => column.forGroupBy == 2).slice(0, 20).map((column: any) => { return column.id }));
    }

    this.reportForm.get('defaultGraphType')?.setValue(GraphType.LINE_CHART);
    this.reportForm.get('businessUnitIds')?.patchValue(
      this.selectedBusinessUnitList.filter((code: any) => 
        this.getAccessibleBusinessUnitList().some((businessUnit: any) => businessUnit.code === code)
      )
    );

    if (this.reportForm.get('reportId')?.value == '20') {
      this.reportForm.get('placementReportOn')?.setValue([6]);
    }
  }

  getModulesList() {
    let tempModules: any = [];
    this.modules.forEach((module: any) => {
      if (!this.hideChildModules || (this.hideChildModules && (this.getModuleInfo(module.code).parentId == 0 || this.getModuleInfo(module.code).parentId == null))) {
        tempModules.push(module);
      }
    });
    return tempModules;
  }

  getModuleInfo(moduleId: number) {
    return this.allModulesData[moduleId];
  }

  getChooseColumns() {
    if (this.reportForm.get('reportId')?.value == '9') {
      return Object.values(this.allColumns).filter((column: any) => (this.checkActivityColumn(column.code))).map((column: any) => {
        return column
      });
    } else {
      return this.allColumns;
    }
  }

  getGroupByColumns() {
    const columns = Object.values(this.allColumnsData || {})
      .filter((column: any) => column.forGroupBy == 2)
      .map((column: any) => ({
        code: column.id,
        name: column.columnName
      }));

    if (this.reportForm.get('reportId')?.value == '9' || this.reportForm.get('reportId')?.value == 9) {
      return columns.filter((column: any) => this.checkActivityColumn(column.code));
    }
    return columns.length ? columns : this.groupByColumns;
  }

  checkActivityColumn(columnId: any) {
    if (this.reportForm.get('filterType')?.value && (this.reportForm.get('filterRole')?.value || this.reportForm.get('filterType')?.value == this.filterType.TEAM)) {
      const tempColumnInfo = this.allColumnsData?.[columnId] || this.allColumnsData?.[Number(columnId)] || this.getColumnInfo(columnId);
      let tempFilterType = this.reportForm.get('filterType')?.value;
      let tempFilterRole = this.reportForm.get('filterRole')?.value;
      if (tempFilterType == this.filterType.TEAM) {
        tempFilterRole = 5;
      }
      const activityReportType = tempColumnInfo?.activityReportType;
      if (activityReportType == null || activityReportType === '') {
        return true;
      }
      const activityTypeStr = String(activityReportType);
      return activityTypeStr == '0' || activityTypeStr.split(',').includes(String(tempFilterRole));
    }
    return true;
  }

  getColumnInfo(columnId: any) {
    // if columnId is a string and starts with 'd' then it is a dimension column
    if (typeof columnId === 'string' && columnId.startsWith('d') && this.reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT) {
      let tempColInfo = this.getDimensionColumnInfo(columnId);
      if (tempColInfo) {
        return {
          columnName: tempColInfo.name || 'Unknown Column',
          columnId: tempColInfo.code,
        }
      }
    } else {
      // if columnId is a number and not a string then it is a regular column
      const columnData = this.allColumnsData[columnId];
      if (columnData) {
        return columnData;
      }
    }

    // Return a default object if column is not found
    return {
      columnName: 'Unknown Column',
      columnId: columnId,
      colDataType: 1,
      searchType: 0,
      forGroupBy: 0,
      forMainFilter: 0,
      listViewFlag: 0,
      activityReportType: '0'
    };
  }

  getDimensionColumnInfo(columnId: string) {
    return this.dimensionColumnsOptions.find((column: any) => column.code == columnId);
  }

  setReportTypes($event: any) {
    if (this.getModuleInfo($event.value)) {
      this.reportForm.get('reportType')?.patchValue(ReportType.DETAILED_REPORT);
      this.reportForm.get('columns')?.setValue([]);
      this.reportForm.get('groupByFilters')?.setValue([]);
      if (this.getModuleInfo($event.value).isDefaultSummarized == 0) {
        this.reportTypes = [
          { name: 'Detailed Report', code: 0 },
          { name: 'Summary Report', code: 1 },
          { name: 'Graph Report', code: 2 },
        ]
      } else if (this.getModuleInfo($event.value).isDefaultSummarized == 1) {
        this.reportTypes = [
          { name: 'Detailed Report', code: 0 }
        ]
      } else if (this.getModuleInfo($event.value).isDefaultSummarized == 2) {
        this.reportTypes = [
          { name: 'Summary Report', code: 1 },
          { name: 'Graph Report', code: 2 },
        ]
      }
      if (this.getModuleInfo($event.value).dimensionReport == 1) {
        this.reportTypes.push({ name: 'Dimension Report', code: 3 });
      }
    }
  }

  async moduleChanged($event: any) {
    this.formData = null;
    this.reportConfig = null;
    this.stages = [];
    this.usersListOptions = [];
    this.conversionRatioFieldsPromise = null;
    this.usersListPromise = null;
    this.reportForm.get('stages')?.setValue([]);
    this.reportForm.get('usersList')?.setValue([]);
    this.setReportTypes($event);
    await this.getReportConfig({ value: $event.value });
    this.filtersFormArray.clear();
    this.reportForm.get('reportType')?.setValue(ReportType.DETAILED_REPORT);
    // this.reportType
  }

  onGroupByFiltersChange(event: any) {
    const groupByFiltersControl = this.reportForm.get('groupByFilters');
    if (groupByFiltersControl) {
      if (event.value.length > this.getGroupByFiltersMaxLength()) {
        event.value.pop();
        groupByFiltersControl.setValue(event.value);
        this._commonMethods.showToastMessage('Please select at most ' + this.getGroupByFiltersMaxLength() + ' columns', '', Severity.error as Severity);
        //groupByFiltersControl.disable();
      } else {
        //groupByFiltersControl.enable();
      }
    }
  }

  onUsersListChange(event: any): void {
    if (Array.isArray(event?.value) && event.value.length === 10) {
      this._commonMethods.showToastMessage(
        'You can select a maximum of 10 users',
        'Warning',
        Severity.warn
      );
    }
  }

  getGroupByFiltersMaxLength() {
    if (this.reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || this.reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT) {
      return 3;
    } else if (this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT) {
      return 1;
    } else {
      return 0;
    }
  }

  reportTypeChanged($event: any) {
    /*const groupByFiltersControl = this.reportForm.get('groupByFilters');
    if (groupByFiltersControl) {
      groupByFiltersControl.removeValidators(Validators.required);
      if (this.reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT)
        groupByFiltersControl.addValidators(Validators.required);
    }
    groupByFiltersControl?.updateValueAndValidity();
    this.setDefaultValues();
    this.reportForm.get('dimensionColumnId')?.removeValidators(Validators.required);
    if (this.reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT) {
      this.reportForm.get('dimensionColumnId')?.addValidators(Validators.required);
    } else {
      this.reportForm.get('dimensionColumnId')?.removeValidators(Validators.required);
    }
    this.reportForm.get('dimensionColumnId')?.updateValueAndValidity();*/
    this.formData = null;
    this.reportConfig = null;
    this.getReportConfig({ value: this.reportForm.get('reportId')?.value });
    this.updateReportFilterValidation();
    const existingGroupByFilters = [...(this.reportForm.get('groupByFilters')?.value || [])];
    this.setDefaultValues();
    if (this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT && existingGroupByFilters.length > 0) {
      this.reportForm.get('groupByFilters')?.setValue([existingGroupByFilters[0]]);
    }
  }

  async instanceTypeChanged($event: any) {
    this.reportForm.get('instanceType')?.setValue(Number($event.value));
    this.formData.instanceType = Number($event.value);
    this.formData.columns = [];
    this.formData.groupByFilters = [];
    this.formData.sortColumns = [];
    this.formData.filters = [];
    this.formData.preDefinedFilters = [];
    this.formData.dateFilterCol = '';
    this.formData.periodValue = 6;
    this.formData.custStartDate = '';
    this.formData.custEndDate = '';
    this.reportConfig = null;
    await this.getReportConfig({ value: this.reportForm.get('reportId')?.value });
    await this.updateReportFilterValidation();
    await this.setDefaultValues();
  }

  get selectedGroupByFilters() {
    const value = this.reportForm.get('groupByFilters')?.value;
    return Array.isArray(value) ? value : [];
  }

  get selectedColumns() {
    const value = this.reportForm.get('columns')?.value;
    return Array.isArray(value) ? value : [];
  }

  get selectedStages() {
    const value = this.reportForm.get('stages')?.value;
    return Array.isArray(value) ? value : [];
  }

  get validStagesForOrderList() {
    const stages = this.reportForm.get('stages')?.value;
    if (!Array.isArray(stages)) {
      return [];
    }
    return stages.filter((stage: any) => {
      return stage != null &&
        stage !== undefined &&
        stage !== '' &&
        (typeof stage === 'string' || typeof stage === 'number');
    });
  }

  getStageInfo(stageCode: any) {
    return this.stages.find((stage) => String(stage.code) === String(stageCode));
  }

  get validColumnsForOrderList() {
    const columns = this.reportForm.get('columns')?.value;
    if (!Array.isArray(columns)) {
      return [];
    }
    // Filter out any null or undefined values and ensure all items are valid
    return columns.filter((column: any) => {
      return column != null &&
        column !== undefined &&
        column !== '' &&
        (typeof column === 'string' || typeof column === 'number');
    });
  }

  get validGroupByFilters() {
    const filters = this.reportForm.get('groupByFilters')?.value;
    if (!Array.isArray(filters)) {
      return [];
    }
    // Filter out any null or undefined values and ensure all items are valid
    return filters.filter((filter: any) => {
      return filter != null &&
        filter !== undefined &&
        filter !== '' &&
        (typeof filter === 'string' || typeof filter === 'number');
    });
  }

  get validSortColumns() {
    const columns = this.reportForm.get('sortColumns')?.value;
    if (!Array.isArray(columns)) {
      return [];
    }
    // Filter out any null or undefined values and ensure all items are valid
    return columns.filter((column: any) => {
      return column != null &&
        column !== undefined &&
        column !== '' &&
        (typeof column === 'object' || typeof column === 'string' || typeof column === 'number');
    });
  }

  get selectedSortColumns() {
    const value = this.reportForm.get('sortColumns')?.value;
    return Array.isArray(value) ? value : [];
  }

  removeGroupByFilter(option: Option) {
    if (!option) {
      return;
    }

    const currentValue = this.reportForm.get('groupByFilters')?.value;
    const index = currentValue.indexOf(option);
    if (index !== -1) {
      currentValue.splice(index, 1);
    }
    this.reportForm.get('groupByFilters')?.setValue([...currentValue]);
  }

  removeColumn(option: Option) {
    if (!option) {
      return;
    }

    const currentValue = this.reportForm.get('columns')?.value;
    const index = currentValue.indexOf(option);
    if (index !== -1) {
      currentValue.splice(index, 1);
    }
    this.reportForm.get('columns')?.setValue([...currentValue]);
    this.syncGraphTypeWithColumns(false);
  }

  removeStage(option: any) {
    if (option == null || option === undefined) {
      return;
    }

    const currentValue = [...(this.reportForm.get('stages')?.value || [])];
    const index = currentValue.findIndex((stage: any) => String(stage) === String(option));
    if (index !== -1) {
      currentValue.splice(index, 1);
      this.reportForm.get('stages')?.setValue(currentValue);
    }
  }

  cleanColumnsData() {
    // Clean columns
    const currentColumns = this.reportForm.get('columns')?.value || [];
    if (Array.isArray(currentColumns)) {
      const cleanedColumns = currentColumns.filter((column: any) => column != null && column !== undefined);
      if (cleanedColumns.length !== currentColumns.length) {
        this.reportForm.get('columns')?.setValue(cleanedColumns);
      }
    } else {
      // If not an array, reset to empty array
      this.reportForm.get('columns')?.setValue([]);
    }

    // Clean groupByFilters
    const currentGroupByFilters = this.reportForm.get('groupByFilters')?.value || [];
    if (Array.isArray(currentGroupByFilters)) {
      const cleanedGroupByFilters = currentGroupByFilters.filter((filter: any) => filter != null && filter !== undefined);
      if (cleanedGroupByFilters.length !== currentGroupByFilters.length) {
        this.reportForm.get('groupByFilters')?.setValue(cleanedGroupByFilters);
      }
    } else {
      // If not an array, reset to empty array
      this.reportForm.get('groupByFilters')?.setValue([]);
    }

    // Clean sortColumns
    const currentSortColumns = this.reportForm.get('sortColumns')?.value || [];
    if (Array.isArray(currentSortColumns)) {
      const cleanedSortColumns = currentSortColumns.filter((column: any) => column != null && column !== undefined);
      if (cleanedSortColumns.length !== currentSortColumns.length) {
        this.reportForm.get('sortColumns')?.setValue(cleanedSortColumns);
      }
    } else {
      // If not an array, reset to empty array
      this.reportForm.get('sortColumns')?.setValue([]);
    }

    // Clean stages
    const currentStages = this.reportForm.get('stages')?.value || [];
    if (Array.isArray(currentStages)) {
      const cleanedStages = currentStages.filter((stage: any) => stage != null && stage !== undefined);
      if (cleanedStages.length !== currentStages.length) {
        this.reportForm.get('stages')?.setValue(cleanedStages);
      }
    } else {
      this.reportForm.get('stages')?.setValue([]);
    }

    // Clean usersList
    const currentUsersList = this.reportForm.get('usersList')?.value || [];
    if (Array.isArray(currentUsersList)) {
      const cleanedUsersList = currentUsersList.filter((user: any) => user != null && user !== undefined);
      if (cleanedUsersList.length !== currentUsersList.length) {
        this.reportForm.get('usersList')?.setValue(cleanedUsersList);
      }
    } else {
      this.reportForm.get('usersList')?.setValue([]);
    }
  }

  removeSortColumn(option: Option) {
    if (!option) {
      return;
    }

    const currentValue = this.reportForm.get('sortColumns')?.value;
    const index = currentValue.indexOf(option);
    if (index !== -1) {
      currentValue.splice(index, 1);
    }
    this.reportForm.get('sortColumns')?.setValue([...currentValue]);
  }

  sortColumn(option: Option, index: number = 0) {
    if (option.sortOrder == 'ASC') {
      option.sortOrder = 'DESC';
    } else {
      option.sortOrder = 'ASC';
    }
  }

  getSortColumn(code: string) {
    return this.sortColumns.find((item: Option) => item.code === code);
  }

  // Add getter for form array
  get preDefinedFiltersArray() {
    return this.reportForm.get('preDefinedFilters') as FormArray;
  }

  // Add method to handle checkbox changes
  onPreDefinedFilterChange(index: number, checked: boolean) {
    const selectedFilters = this.preDefinedFilterOptions
      .filter((_, i) => this.preDefinedFiltersArray.at(i).value)
      .map(filter => filter.code);
    this.reportForm.get('preDefinedFilters')?.setValue(selectedFilters);
  }

  /**
   * This getter method is used to return the fields order related form array
   * @author Raghavender on 01/12/2023
   */
  get filtersFormArray(): any {
    return this.reportForm.get('filters') as FormArray;
  }

  /** Report Filters Start */
  /** @author: Raghavender
   * @description: This method is used to add a new filter to the report form
   */
  addFilter(dataObject: any = {}, index: number = this.filtersFormArray.length): any {
    const filterConditionKey = 'filterCondition' + index;
    const filterGroupConfig: Record<string, any> = {
      id: this.fb.control(dataObject.id || null),
      columnId: this.fb.control(dataObject.columnId || '', [Validators.required]),
      dataType: this.fb.control(dataObject.dataType || '', [Validators.required]),
      value: this.fb.control(dataObject.value || null),
      startDate: this.fb.control(dataObject.startDate || null),
      endDate: this.fb.control(dataObject.endDate || null),
      options: this.fb.control(dataObject.options || [])
    };

    // First filter (index 0) has no AND/OR condition — matches legacy filter_condition{$key} when $key != 0
    if (index > 0) {
      filterGroupConfig[filterConditionKey] = this.fb.control(
        dataObject[filterConditionKey] ||
        dataObject.filterAndOrCondition ||
        dataObject.filterCondition ||
        'AND'
      );
    }

    return this.fb.group(filterGroupConfig);
  }

  addApiFilterBlock() {
    // Check if there are existing filters
    if (this.filtersFormArray.length > 0) {
      // Get the last filter
      const lastFilterIndex = this.filtersFormArray.length - 1;
      const lastFilter = this.filtersFormArray.at(lastFilterIndex);

      // Check if the last filter is complete
      if (!this.isFilterComplete(lastFilter)) {
        // Mark the last filter as touched to show validation errors
        lastFilter.markAllAsTouched();

        // Show error message
        /* this._commonMethods.showToastMessage('Please complete the current filter before adding a new one', '', Severity.error as Severity); */
        return;
      }
    }

    // If no filters exist or last filter is complete, add new filter
    this.filtersFormArray.push(this.addFilter());
  }

  /**
   * Check if a filter is complete based on its data type
   */
  isFilterComplete(filter: any): boolean {
    const columnId = filter.get('columnId')?.value;
    const dataType = filter.get('dataType')?.value;
    const value = filter.get('value')?.value;
    const startDate = filter.get('startDate')?.value;
    const endDate = filter.get('endDate')?.value;

    // Must have column and dataType selected
    if (!columnId || !dataType) {
      return false;
    }

    // Check based on dataType
    if (dataType == 13 || dataType == 14) {
      // Date range validation - both start and end date required
      return !!(startDate && endDate);
    } else if (dataType == 3 || dataType == 4) {
      // Null/Not null conditions - no value needed
      return true;
    } else {
      // Other conditions - value required
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return !!(value && value.toString().trim() !== '');
    }
  }

  removeApiFilterBlock(index: number) {
    // Clean up the max and min end dates for this filter
    delete this.filterMaxEndDates[index];
    delete this.filterMinEndDates[index];
    
    this.filtersFormArray.removeAt(index);
  }

  updateColumnTypeFilters(index: number = 0) {
    this.tempColumnTypeFilters[index] = [];
    this.tempFilterDropdownOptions[index] = [];
    if (this.filtersFormArray.at(index).get('columnId').value) {
      let columnId = this.filtersFormArray.at(index).get('columnId').value;
      let colDataType = this.getColumnInfo(columnId).colDataType;
      this.filtersFormArray.at(index).get('dataType').setValue('');
      this.tempColumnTypeFilters[index] = this.columnTypeFilters[colDataType];
    }
  }

  resetColumnTypeFilter(index: number = 0) {
    this.filtersFormArray.at(index).get('dataType').setValue("");
    this.filtersFormArray.at(index).get('value').setValue("");
    this.filtersFormArray.at(index).get('startDate').setValue("");
    this.filtersFormArray.at(index).get('endDate').setValue("");
    this.tempFilterDropdownOptions[index] = [];
    
    // Clear the max and min end dates for this filter
    delete this.filterMaxEndDates[index];
    delete this.filterMinEndDates[index];
  }
  getColTypeFilters(index: number = 0) {
    if (this.filtersFormArray.at(index).get('columnId').value)
      return this.tempColumnTypeFilters[index];
    else
      return [];
  }
  getDropdownValues(index: number = 0) {
    return (this.tempFilterDropdownOptions[index]) ? this.tempFilterDropdownOptions[index] : [];
  }

  /**
   * Left-side filter dropdowns post reportId, columnId, and report criteria only.
   * Column filters are not included.
   */
  private buildFilterDropdownPayload(columnId: any, extra: Record<string, any> = {}): any {
    const form = this.reportForm.getRawValue();
    const reportId = [form.reportId, this.formData?.reportId, this.reportConfig?.id, this.savedReportData?.savedReports?.[0]?.reportId, this.savedReportData?.id]
      .find((value) => value !== undefined && value !== null && value !== '');
    const filterType = (form.filterType != null && form.filterType !== '') ? form.filterType : 1;
    const preDefFilterIds: number[] = [];
    if (form.preDefinedFilters) {
      form.preDefinedFilters.forEach((filter: any) => {
        if (filter && filter[0]) {
          preDefFilterIds.push(filter[0]);
        }
      });
    }

    const payload: any = {
      columnId: columnId != null ? String(columnId) : '',
      businessUnitIds: form.businessUnitIds?.length ? form.businessUnitIds : this.formData?.businessUnitIds,
      filterType,
      reportType: form.reportType ?? this.formData?.reportType,
      dateFilterCol: form.dateFilterCol || this.formData?.dateFilterCol,
      periodValue: form.periodValue ?? this.formData?.periodValue,
      preDefFilterIds,
      columnsList: form.columns,
      groupByColumnsList: form.groupByFilters,
      groupByLevel: form.groupByLevel,
      dimensionColumnId: form.dimensionColumnId,
      enableHierarchySecurity: form.enableHierarchySecurity ?? false,
      ...extra,
      reportId: reportId != null ? String(reportId) : '',
      loadAllOption: true,
    };

    if (Number(payload.periodValue) === 10) {
      payload.custStartDate = this.formatQueryDate(form.custStartDate || this.formData?.custStartDate);
      payload.custEndDate = this.formatQueryDate(form.custEndDate || this.formData?.custEndDate);
    }
    if (Number(reportId) === 9) {
      payload.filterType = Number(form.filterType);
      if (Number(form.filterType) === this.filterType.ROLE) {
        payload.filterRole = form.filterRole;
        payload.roleUserIds = form.roleUserIds;
      } else if (Number(form.filterType) === this.filterType.TEAM) {
        payload.teamList = form.teamList;
        payload.teamMembersList = form.teamMembersList;
      }
    } else if ([14, 16, 36].includes(Number(reportId) || 0)) {
      payload.teamList = form.teamList;
      payload.teamMembersList = form.teamMembersList;
    } else if (Number(reportId) === 20) {
      payload.placementReportOn = form.placementReportOn;
      payload.currencyDetails = form.currencyDetails;
      payload.currencyConversion = form.currencyConversion;
      payload.instanceType = form.instanceType;
    } else if (Number(reportId) === 5) {
      payload.marketingStatus = form.marketingStatus;
      payload.benchStatus = form.benchStatus;
      payload.benchSubStatus = form.benchSubStatus;
    } else if (Number(reportId) === 6) {
      payload.includePipelines = form.includePipelines ?? false;
    } else if (Number(reportId) === 109 || Number(reportId) === 110) {
      payload.stages = form.stages;
      if (Number(reportId) === 110) {
        payload.usersList = form.usersList;
      }
    }
    return payload;
  }

  private formatQueryDate(value: any): any {
    if (value == null || value === '') {
      return value;
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.timezoneTransformPipe.transform(value, 'yyyy-MM-dd', this.loggedInUserTimeZone);
    }
    return value;
  }
  async updateFilterDropdownOptions(index: number = 0) {
    if (!this.tempFilterDropdownOptions[index]) {
      this.tempFilterDropdownOptions[index] = [];
    }
    if (this.tempFilterDropdownOptions[index].length == 0
      && this.filtersFormArray.at(index).get('dataType').value
      && this.filtersFormArray.at(index).get('dataType').value != 3
      && this.filtersFormArray.at(index).get('dataType').value != 4) {
        
      let columnId = this.filtersFormArray.at(index).get('columnId').value;
      let reportId = this.reportForm.get('reportId')?.value;
      if (this.getColumnInfo(columnId).colDataType == 4 || this.getColumnInfo(columnId).colDataType == 5 || this.getColumnInfo(columnId).colDataType == 7) {
        if (this.reportForm.get('businessUnitIds')?.value && this.reportForm.get('businessUnitIds')?.value.length > 0) {
          this._commonHttpService.makeFilterDropDowns(this.buildFilterDropdownPayload(columnId)).subscribe((res: any) => {
            if (res.status == 1) {
              this.tempFilterDropdownOptions[index] = res.options;
              this.filtersFormArray.at(index).get('options').setValue(this.tempFilterDropdownOptions[index]);
            }
          });
        } else {
          this._commonMethods.showToastMessage('Please select at least one Business unit', '', Severity.error as Severity);
          this.filtersFormArray.at(index).get('dataType').reset();
        }
      }

      /* if (this.getColumnInfo(columnId).colDataType == 1 || this.getColumnInfo(columnId).colDataType == 2) {
        if(this.filtersFormArray.at(index).get('dataType').value == 3){
          this.filtersFormArray.at(index).get('value').removeValidators(Validators.required);
        } else {
          this.filtersFormArray.at(index).get('value').addValidators(Validators.required);
        }
        this.filtersFormArray.at(index).get('value').updateValueAndValidity();
        // this.filtersFormArray.at(index).get('value').addValidators(Validators.required);
      } else {
        this.filtersFormArray.at(index).get('value').removeValidators(Validators.required);
        this.filtersFormArray.at(index).get('value').updateValueAndValidity();
      } */



    }




    this.filtersFormArray.at(index).get('value').setValue("");
    this.filtersFormArray.at(index).get('startDate').setValue("");
    this.filtersFormArray.at(index).get('endDate').setValue("");
  }
  removeFilter(index: number = 0) {
    if (this.filtersFormArray.at(index).get('id') && this.filtersFormArray.at(index).get('id').value != '')
      this.deletedFilterIds.push(this.filtersFormArray.at(index).get('id').value);

    // Clean up the max and min end dates for this filter
    delete this.filterMaxEndDates[index];
    delete this.filterMinEndDates[index];

    const filtersSnapshot = this.filtersFormArray.controls.map((control: any, i: number) => {
      const value = { ...control.value };
      if (i > 0) {
        value.filterAndOrCondition = value['filterCondition' + i] || 'AND';
      }
      Object.keys(value).forEach((key) => {
        if (key.startsWith('filterCondition')) {
          delete value[key];
        }
      });
      return value;
    });
    filtersSnapshot.splice(index, 1);

    while (this.filtersFormArray.length > 0) {
      this.filtersFormArray.removeAt(0);
    }

    filtersSnapshot.forEach((data: any, i: number) => {
      this.filtersFormArray.push(this.addFilter(data, i));
    });
  }

  dimensionColumnChanged(event: any) {
    this.reportForm.get('columns')?.setValue([]);
    this.dimensionColumnsOptions = [];
    if (event.value) {
      this._commonHttpService.makeFilterDropDowns(this.buildFilterDropdownPayload(event.value, { isDimensionReport: 1 })).subscribe((res: any) => {
        if (res.status == 1) {
          this.dimensionColumnsOptions = this.savedReportService.normalizeDimensionColumnOptions(res.options);
        }
      });
    }
  }


  /** Report Filters End */

  ngOnDestroy() {
    if (this.formDataSubscription) {
      this.formDataSubscription.unsubscribe();
    }
    if (this.columnsValueChangesSubscription) {
      this.columnsValueChangesSubscription.unsubscribe();
    }
  }

  // Drag and Drop methods for custom displays
  onDragStart(event: DragEvent, index: number, listType: 'columns' | 'groupByFilters' | 'sortColumns' | 'stages') {
    if (event.dataTransfer) {
      event.dataTransfer.setData('text/plain', index.toString());
      event.dataTransfer.effectAllowed = 'move';
    }
    // Add visual feedback
    const target = event.target as HTMLElement;
    if (target) {
      target.style.opacity = '0.5';
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';

    // Add visual feedback for drop zone
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '#f0f0f0';
    }
  }

  onDragLeave(event: DragEvent) {
    // Remove visual feedback when leaving drop zone
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '';
    }
  }

  onDrop(event: DragEvent, dropIndex: number, listType: 'columns' | 'groupByFilters' | 'sortColumns' | 'stages') {
    event.preventDefault();

    // Remove visual feedback
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('border-bottom')) {
      target.style.backgroundColor = '';
    }

    const dragIndex = parseInt(event.dataTransfer!.getData('text/plain'));

    if (dragIndex === dropIndex) return;

    let currentItems: any[] = [];
    let formControlName = '';

    switch (listType) {
      case 'columns':
        currentItems = [...this.reportForm.get('columns')?.value || []];
        formControlName = 'columns';
        break;
      case 'groupByFilters':
        currentItems = [...this.reportForm.get('groupByFilters')?.value || []];
        formControlName = 'groupByFilters';
        break;
      case 'sortColumns':
        currentItems = [...this.reportForm.get('sortColumns')?.value || []];
        formControlName = 'sortColumns';
        break;
      case 'stages':
        currentItems = [...this.reportForm.get('stages')?.value || []];
        formControlName = 'stages';
        break;
    }

    if (currentItems.length > 0) {
      const draggedItem = currentItems[dragIndex];
      currentItems.splice(dragIndex, 1);
      currentItems.splice(dropIndex, 0, draggedItem);

      this.reportForm.get(formControlName)?.setValue(currentItems);
      this._changeDetectorRef.detectChanges();
    }
  }

  onDragEnd(event: DragEvent) {
    // Reset visual feedback
    const target = event.target as HTMLElement;
    if (target) {
      target.style.opacity = '';
    }
  }

  // Safe wrapper methods to ensure no null values reach PrimeNG
  getSafeColumnsForOrderList(): any[] {
    try {
      const result = this.validColumnsForOrderList;
      return Array.isArray(result) ? result : [];
    } catch (error) {
      return [];
    }
  }

  getSafeStagesForOrderList(): any[] {
    try {
      const result = this.validStagesForOrderList;
      return Array.isArray(result) ? result : [];
    } catch (error) {
      return [];
    }
  }

  getSafeGroupByFilters(): any[] {
    try {
      const result = this.validGroupByFilters;
      return Array.isArray(result) ? result : [];
    } catch (error) {
      return [];
    }
  }

  getSafeSortColumns(): any[] {
    try {
      const result = this.validSortColumns;
      return Array.isArray(result) ? result : [];
    } catch (error) {
      return [];
    }
  }

  startEditing(item: any, columnName: any) {
    if (!item) {
      return;
    }

    this.editColumn = columnName || '';
    this.editingItemCode = item;

    // Focus the input field after a short delay to ensure DOM is updated
    // setTimeout(() => {
    const inputElement = document.getElementById(`editColumn_${item}`) as HTMLInputElement;
    if (inputElement) {
      inputElement.focus();
      inputElement.select();
    }
    // }, 100);
  }

  stopEditing() {
    this.editingItemCode = null;
    this.editColumn = '';
  }

  updateItemName(item: any, newValue: string) {
    if (!item) {
      this.stopEditing();
      return;
    }

    /* if (newValue && newValue.trim()) {
      // Update the column name in the allColumnsData
      if (this.allColumnsData[item]) {
        this.allColumnsData[item].columnName = newValue.trim();
      }

      // Update the form value to trigger change detection
      const currentColumns = this.reportForm.get('columns')?.value || [];
      this.reportForm.get('columns')?.setValue([...currentColumns]);

      // Trigger change detection
      this._changeDetectorRef.detectChanges();
    } */
    if (newValue && newValue.trim()) {
      // ✅ ONLY update the column name in the allColumnsData
      if (this.allColumnsData[item]) {
        this.allColumnsData[item].columnName = newValue.trim();
      }

      // ❌ REMOVE THESE LINES - No form update or change detection
      // const currentColumns = this.reportForm.get('columns')?.value || [];
      // this.reportForm.get('columns')?.setValue([...currentColumns]);
      // this._changeDetectorRef.detectChanges();
    }
    this.stopEditing();
  }


  /*onTeamChange(event: any) {
    this.teamMembers = [];
    event.value.forEach((team: { code: number, name: string }) => {
      const teamMembersArray = this.teamsAndRolesResponse.teamData.teamMembers[team.code];
      if (teamMembersArray && Array.isArray(teamMembersArray) && this.teamMembers.filter((member: { code: number, name: string }) => member.code == team.code).length == 0) {
        this.teamMembers.push(...teamMembersArray);
      }
    });
  }*/

  getRoleWiseUsersList() {
    return this.teamsAndRolesResponse.userRestrictionFields[this.reportForm.get('filterRole')?.value];
  }

  getTeamMembers() {
    this.teamMembers = [];
    if (this.reportForm.get('teamList')?.value) {
      this.reportForm.get('teamList')?.value.forEach((team: any) => {
        const teamMembersArray = this.teamsAndRolesResponse.teamData.teamMembers[team];
        /*(if (teamMembersArray && Array.isArray(teamMembersArray) && this.teamMembers.filter((member: {code: number, name: string }) => member.code == team).length == 0) {
          this.teamMembers.push(...teamMembersArray);
        }*/
        if (teamMembersArray && Array.isArray(teamMembersArray)) {
          teamMembersArray.forEach((member: any) => {
            if (this.teamMembers.filter((item: any) => item.code == member.code).length == 0) {
              this.teamMembers.push(member);
            }
          });
        }
      });
    }
    return this.teamMembers;
  }

  getBenchSubStatus() {
    let benchSubStatus: any[] = [];
    let tempBenchSubStatus: any[] = [];
    if (this.reportForm.get('benchStatus')?.value && this.reportForm.get('benchStatus')?.value.length > 0) {
      this.reportForm.get('benchStatus')?.value.forEach((status: any) => {
        if (this.talentBenchReportOptions.subStatuses[status]) {
          tempBenchSubStatus = this.talentBenchReportOptions.subStatuses[status];
          tempBenchSubStatus.forEach((subStatus: any) => {
            if (benchSubStatus.filter((item: any) => item.code == subStatus.code).length == 0) {
              benchSubStatus.push(subStatus);
            }
          });
        }
      });
    }
    return benchSubStatus;
  }

  onFilterTypeChange(event: any) {
    this.reportForm.get('columns')?.setValue([]);
    this.reportForm.get('roleUserIds')?.setValue([]);
    this.reportForm.get('teamList')?.setValue([]);
    this.reportForm.get('teamMembersList')?.setValue([]);
    this.reportForm.get('groupByLevel')?.setValue(event.value == 2 ? 1 : null);
    this._changeDetectorRef.detectChanges();
  }

  onFilterRoleChange(event: any) {
    this.reportForm.get('columns')?.setValue([]);
    this.reportForm.get('roleUserIds')?.setValue([]);
    this.reportForm.get('teamList')?.setValue([]);
    this.reportForm.get('teamMembersList')?.setValue([]);
    this._changeDetectorRef.detectChanges();
  }

  onTeamListChange() {
    this.reportForm.get('teamMembersList')?.setValue([]);
  }

  showRequiredFields() {
    if (this.formData) {
      this.setReportTypes({ value: this.formData.reportId });
      setTimeout(() => {
        this.validateReportForm();
      }, 1000);
    }
  }

  async updateReportFilterValidation(): Promise<void> {
    // Adding required validation to definedFilter if dateTypeFilters is not empty
    if (this.dateTypeFilters.length > 0) {
      this.reportForm.get('dateFilterCol')?.addValidators(Validators.required);
    } else {
      this.reportForm.get('dateFilterCol')?.removeValidators(Validators.required);
    }
    this.reportForm.get('dateFilterCol')?.updateValueAndValidity();

    // Adding required validation to dimensionColumnId if reportType is DIMENSION_REPORT
    if (this.reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT) {
      this.reportForm.get('dimensionColumnId')?.addValidators(Validators.required);
    } else {
      this.reportForm.get('dimensionColumnId')?.removeValidators(Validators.required);
    }
    this.reportForm.get('dimensionColumnId')?.updateValueAndValidity();

    // Adding required validation to custStartDate and custEndDate if periodValue is 10 (custom date range)
    if (+this.reportForm.get('periodValue')?.value === 10) {
      this.reportForm.get('custStartDate')?.addValidators(Validators.required);
      this.reportForm.get('custEndDate')?.addValidators(Validators.required);
    } else {
      this.reportForm.get('custStartDate')?.removeValidators(Validators.required);
      this.reportForm.get('custEndDate')?.removeValidators(Validators.required);
    }
    this.reportForm.get('custStartDate')?.updateValueAndValidity();
    this.reportForm.get('custEndDate')?.updateValueAndValidity();

    // Adding required validation to groupByFilters if reportType is SUMMARY_REPORT, DIMENSION_REPORT, or GRAPH_REPORT
    if (this.reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || this.reportForm.get('reportType')?.value == ReportType.DIMENSION_REPORT || this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT) {
      this.reportForm.get('groupByFilters')?.addValidators(Validators.required);
    } else {
      this.reportForm.get('groupByFilters')?.removeValidators(Validators.required);
    }
    this.reportForm.get('groupByFilters')?.updateValueAndValidity();

    // Adding required validation to columns if reportType is SUMMARY_REPORT or GRAPH_REPORT
    this.reportForm.get('roleUserIds')?.removeValidators(Validators.required);
    this.reportForm.get('teamList')?.removeValidators(Validators.required);
    this.reportForm.get('teamMembersList')?.removeValidators(Validators.required);

    const reportId = +this.reportForm.get('reportId')?.value;
    this.reportForm.get('filterRole')?.removeValidators(Validators.required);
    if (reportId === 9) {
      if (this.reportForm.get('filterType')?.value == this.filterType.ROLE) {
        this.reportForm.get('filterRole')?.addValidators(Validators.required);
        this.reportForm.get('roleUserIds')?.addValidators(Validators.required);
      } else if (this.reportForm.get('filterType')?.value == this.filterType.TEAM) {
        this.reportForm.get('teamList')?.addValidators(Validators.required);
        this.reportForm.get('teamMembersList')?.addValidators(Validators.required);
      }
    } else if ([14, 16, 36].includes(reportId)) {
      // Team / Team Members fields are shown only for these reports
      this.reportForm.get('teamList')?.addValidators(Validators.required);
      this.reportForm.get('teamMembersList')?.addValidators(Validators.required);
    }

    this.reportForm.get('filterRole')?.updateValueAndValidity();
    this.reportForm.get('roleUserIds')?.updateValueAndValidity();
    this.reportForm.get('teamList')?.updateValueAndValidity();
    this.reportForm.get('teamMembersList')?.updateValueAndValidity();

    if (this.reportForm.get('reportId')?.value == '20') {
      this.reportForm.get('currencyDetails')?.removeValidators(Validators.required);
      this.reportForm.get('placementReportOn')?.addValidators(Validators.required);
      if (this.reportForm.get('currencyConversion')?.value) {
        this.reportForm.get('currencyDetails')?.addValidators(Validators.required);
      }
      this.reportForm.get('currencyDetails')?.updateValueAndValidity();
    } else {
      this.reportForm.get('placementReportOn')?.removeValidators(Validators.required);
    }
    this.reportForm.get('placementReportOn')?.updateValueAndValidity();
    // if (this.showAllFields && !this.reportForm.get('viewToAll')?.value) {
    //   this.reportForm.get('viewRoleIds')?.addValidators(Validators.required);
    // } else {
    //   this.reportForm.get('viewRoleIds')?.removeValidators(Validators.required);
    // }
    // this.reportForm.get('viewRoleIds')?.updateValueAndValidity();
  }

  async saveReport(newReport: boolean = false) {
    await this.updateReportFilterValidation();
    this.reportForm.get('reportName')?.addValidators(Validators.required);
    this.reportForm.get('reportDesc')?.addValidators(Validators.required);
    this.reportForm.get('reportName')?.updateValueAndValidity();
    this.reportForm.get('reportDesc')?.updateValueAndValidity();
    if (this.reportForm.get('viewToAll')?.value) {
      this.reportForm.get('viewRoleIds')?.removeValidators(Validators.required);
    } else {
      this.reportForm.get('viewRoleIds')?.addValidators(Validators.required);
    }
    this.reportForm.get('viewRoleIds')?.updateValueAndValidity();

    // Mark all form controls as touched to trigger error message display
    this.reportForm.markAllAsTouched();
    this.checkFormDirty();

    this.validateReportForm().then((res: boolean) => {
      //console.log(this.getSavingReportData(newReport));return;
      if (res) {
        this.editingItemCode = null;
        this._commonHttpService.saveReport(this.getSavingReportData(newReport)).subscribe((res: any) => {
          if (res.status == 1) {
            this.reportForm.reset();
            this.filtersFormArray.clear();
            this.clearAllFilterMaxEndDates();
            this.preDefinedFiltersArray.clear();
            this._commonMethods.showToastMessage(res.message, 'Success', Severity.success);
            // Set the data and trigger the subscription
            this._commonService.setReloadSavedReportData = { moduleId: res.reportId, reportId: res.savedReportId, reloadSavedReportData: true };
            this._commonService.triggerGetSavedReportData();

            this.router.navigate(['/report-details', res.reportId, res.savedReportId]);
            this._commonService.formLoaded = false;
            this._commonService.hideGenerateReportForm();
          } else {
            this._commonMethods.showToastMessage(res.message, '', Severity.error as Severity);
          }
        });
      }
    });
  }

  getSavingReportData(newReport: boolean = false) {
    let tempFormData = { ...this.reportForm.value };
    tempFormData.savedReportId = null
    let moduleInfo = this.getModuleInfo(tempFormData.reportId);
    let existingColumns: any = [];
    let existingGroupByFilters: any = [];
    let recordsPerPageId: any = null; // type 1
    let dateFilterColId: any = null; // type 2
    let predefinedColId: any = null; // type 3
    let existingSortColumns: any = [];
    let filters: any = [];
    if (moduleInfo) {
      tempFormData.parentModuleId = (moduleInfo.parentId) ? moduleInfo.parentId : moduleInfo.id;
    } else {
      tempFormData.parentModuleId = tempFormData.id; // fallback to reportId if module not found
    }
    if (!newReport && Object.keys(this.savedReportData).length > 0 && this.savedReportData.savedReports[0] && this.savedReportData.savedReports[0].isAdminReport == 0) {
      let tempSavedReportData = { ...this.savedReportData.savedReports[0] };
      tempFormData.savedReportId = tempSavedReportData.id;
      const { columns, groupByFilters } = this.savedReportService.processSavedReportColumns(tempSavedReportData, true);
      existingColumns = columns;
      existingGroupByFilters = groupByFilters;

      const {
        savedReportFilters,
        sortColumns,
        dateFilterCol,
        periodValue,
        tempPreDefFilterIds,
        recordsPerPage
      } = this.savedReportService.processSavedReportFilters(tempSavedReportData, this.allColumnsData, true);
      existingSortColumns = sortColumns;
      dateFilterColId = (dateFilterCol && typeof dateFilterCol === 'object') ? (dateFilterCol as any).id : null;
      recordsPerPageId = (recordsPerPage && typeof recordsPerPage === 'object') ? (recordsPerPage as any).id : null;
      predefinedColId = (tempPreDefFilterIds && Object.keys(tempPreDefFilterIds).length > 0 && typeof tempPreDefFilterIds === 'object') ? (tempPreDefFilterIds as any).id : null;
    }

    let tempColumns: any = [];
    let tempColObj: any = {};
    for (let [index, column] of this.reportForm.get('columns')?.value.entries()) {
      tempColObj = {
        columnId: column,
        columnName: this.getColumnInfo(column).columnName,
        id: existingColumns[column]?.id || null,
        forGroupBy: 0,
        isCustomField: 0,
        isDimensionColumn: 0,
        columnOrder: index + 1
      };
      if (tempColObj.columnId && typeof tempColObj.columnId === 'string') {
        if (tempColObj.columnId.startsWith('c')) {
          tempColObj.columnId = tempColObj.columnId.replace('c', '');
          tempColObj.isCustomField = 1;
        }
        if (tempColObj.columnId.startsWith('_d')) {
          tempColObj.columnId = tempColObj.columnId.replace('_d', '-d');
          tempColObj.isDimensionColumn = 1;
        }
        if (tempColObj.columnId.startsWith('d')) {
          tempColObj.columnId = tempColObj.columnId.replace('d', '');
          tempColObj.isDimensionColumn = 1;
        }
      }
      if (this.reportForm.get('reportType')?.value == ReportType.SUMMARY_REPORT || this.reportForm.get('reportType')?.value == ReportType.GRAPH_REPORT) {
        tempColObj.forGroupBy = 0;
      }
      tempColumns.push(tempColObj);
    }

    // Group by columns
    let tempGroupByColObj: any = {};
    if (this.reportForm.get('reportType')?.value != ReportType.DETAILED_REPORT) {
      for (let [index, column] of this.reportForm.get('groupByFilters')?.value.entries()) {
        tempGroupByColObj = {
          columnId: column,
          columnName: this.getColumnInfo(column).columnName,
          id: existingGroupByFilters[column]?.id || null,
          forGroupBy: 1,
          columnOrder: index + 1
        }
        if (tempGroupByColObj.columnId && typeof tempGroupByColObj.columnId === 'string' && tempGroupByColObj.columnId.startsWith('c')) {
          tempGroupByColObj.columnId = tempGroupByColObj.columnId.replace('c', '');
          tempGroupByColObj.isCustomField = 1;
        }
        tempColumns.push(tempGroupByColObj);
      }
    }
    tempFormData.columns = tempColumns;

    // No fo records per page saving
    let tempRecordsPerPage = {
      id: recordsPerPageId,
      type: 1,
      savedReportId: tempFormData.savedReportId,
      recordsPerPage: this.recordsPerPage
    }
    filters.push(tempRecordsPerPage);

    // Date range filter
    let tempDateRange = {
      id: dateFilterColId,
      type: 2,
      savedReportId: tempFormData.savedReportId,
      columnId: (tempFormData.dateFilterCol) ? tempFormData.dateFilterCol : 0,
      startDate: this.timezoneTransformPipe.transform(tempFormData.custStartDate, 'yyyy-MM-dd', this.loggedInUserTimeZone),
      endDate: this.timezoneTransformPipe.transform(tempFormData.custEndDate, 'yyyy-MM-dd', this.loggedInUserTimeZone),
      periodValue: tempFormData.periodValue,
      isCustomField: 0
    }
    if (tempDateRange && typeof tempDateRange.columnId === 'string' && tempDateRange.columnId.startsWith('c')) {
      tempDateRange.columnId = tempDateRange.columnId.replace('c', '');
      tempDateRange.isCustomField = 1;
    }
    filters.push(tempDateRange);
    if (tempFormData.preDefinedFilters) {
      let tempPreDefinedFilters: number[] = [];
      tempFormData.preDefinedFilters.forEach((filter: any) => {
        if (filter && filter[0]) {
          tempPreDefinedFilters.push(filter[0]);
        }
      });
      // Predefined filter
      let tempPreDefFilter = {
        id: predefinedColId,
        type: 3,
        savedReportId: tempFormData.savedReportId,
        columnId: 0,
        preDefFilterIds: tempPreDefinedFilters ? tempPreDefinedFilters.join(',') : ''
      }
      filters.push(tempPreDefFilter);
    }

    // Sort columns
    let tempSortColumns: any = [];
    if (tempFormData.sortColumns) {
      tempFormData.sortColumns.forEach((sortColumn: any, index: number) => {
        let tempSortColObj: any = {
          id: existingSortColumns.filter((item: any) => item.code == sortColumn.code)[0]?.id || null,
          type: 5,
          columnId: sortColumn.code,
          filterValue: sortColumn.sortOrder,
          filterOrder: index + 1,
          isCustomField: 0
        }
        if (tempSortColObj.columnId && typeof tempSortColObj.columnId === 'string' && tempSortColObj.columnId.startsWith('c')) {
          tempSortColObj.columnId = tempSortColObj.columnId.replace('c', '');
          tempSortColObj.isCustomField = 1;
        }
        tempSortColumns.push(tempSortColObj);
      });
    }
    filters.push(...tempSortColumns);
    // Left side filters
    let leftSideFilters: any[] = [];
    if (tempFormData.filters) {
      let tempLeftSideFilters: any[] = tempFormData.filters;
      tempLeftSideFilters.forEach((filter: any, index: number) => {
        let tempFilter = { ...filter };
        tempFilter.type = 4;
        if (tempFilter.filterValue = tempFilter.value) {
          delete tempFilter.value;
        }
        if (tempFilter.columnId && typeof tempFilter.columnId === 'string' && tempFilter.columnId.startsWith('c')) {
          tempFilter.columnId = tempFilter.columnId.replace('c', '');
          tempFilter.isCustomField = 1;
        }
        if (tempFilter.filterType = tempFilter.dataType) {
          delete tempFilter.dataType;
        }
        if (tempFilter.filterType == 15 || tempFilter.filterType == 16) {
          tempFilter.filterValue = tempFilter.filterValue.join(',');
        }

        let filterSeachType = this.getColumnInfo(tempFilter.columnId).searchType || 0;
        const filterTypeNum = Number(tempFilter.filterType);
        if (![13, 14].includes(filterTypeNum) && filterSeachType == 2)
          tempFilter.startDate = this.timezoneTransformPipe.transform(tempFilter.filterValue, 'yyyy-MM-dd', this.loggedInUserTimeZone);
        if ([13, 14].includes(filterTypeNum) && filterSeachType == 2) {
          tempFilter.startDate = this.timezoneTransformPipe.transform(tempFilter.startDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
          tempFilter.endDate = this.timezoneTransformPipe.transform(tempFilter.endDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
        }
        tempFilter.filterOrder = index + 1;
        tempFilter.filterAndOrCondition = index > 0
          ? (tempFilter['filterCondition' + index] || 'AND')
          : '';
        // Dropdown options are UI-only; do not send in save-report payload
        delete tempFilter.options;
        leftSideFilters.push(tempFilter);
      });
      filters.push(...leftSideFilters);
    }
    tempFormData.filters = filters;
    // Same date conversion as get-report: send yyyy-MM-dd in the user's timezone
    // instead of the Date object's UTC ISO string (e.g. 2026-09-29T18:30:00.000Z).
    if (tempFormData.periodValue == 10) {
      tempFormData.custStartDate = this.timezoneTransformPipe.transform(tempFormData.custStartDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
      tempFormData.custEndDate = this.timezoneTransformPipe.transform(tempFormData.custEndDate, 'yyyy-MM-dd', this.loggedInUserTimeZone);
    }
    // Backend expects 0 when no role is selected (not null)
    if (tempFormData.filterRole == null || tempFormData.filterRole === '') {
      tempFormData.filterRole = 0;
    }
    return tempFormData;
  }

  getGraphTypeOptions() {
    const columnsCount = this.reportForm.get('columns')?.value?.length ?? 0;
    return this._commonService.getAllGraphItemsArray(columnsCount);
  }

  /**
   * Keeps default graph type compatible with the number of Y-Axis columns.
   * Single-Y-Axis graphs are only allowed when exactly one column is selected.
   */
  syncGraphTypeWithColumns(showToast: boolean = true): void {
    if (this.reportForm.get('reportType')?.value != ReportType.GRAPH_REPORT) {
      return;
    }

    const columnsCount = this.reportForm.get('columns')?.value?.length ?? 0;
    const currentGraphType = this.reportForm.get('defaultGraphType')?.value;

    if (!currentGraphType || columnsCount === 0) {
      return;
    }

    if (!this._commonService.isGraphTypeAllowedForColumns(currentGraphType, columnsCount)) {
      const fallback = GraphType.LINE_CHART;
      this.reportForm.get('defaultGraphType')?.setValue(fallback);
      this._commonService.defaultGraphType = fallback;

      if (showToast) {
        this._commonMethods.showToastMessage(
          'The selected graph type is not supported with multiple Y-Axis columns. Default graph type has been changed to Line.',
          'Graph Type Updated',
          Severity.warn
        );
      }
    }
  }

  disableSaveReportButton() {
    return Object.keys(this.savedReportData).length > 0 && this.savedReportData.savedReports[0] && this.savedReportData.savedReports[0].isAdminReport == 0;
  }
  isReportAlreadySaved() {
    return Object.keys(this.savedReportData).length > 0 && this.savedReportData.savedReports[0];
  }

  isAdminReport(): boolean {
    return !!(this.savedReportData?.savedReports?.[0] && this.savedReportData.savedReports[0].isAdminReport == 1);
  }

  isChildReport(): boolean {
    const parentIdFromConfig = this.reportConfig?.parentId;
    if (parentIdFromConfig !== undefined && parentIdFromConfig !== null && parentIdFromConfig !== 0) {
      return true;
    }
    const reportId = this.reportForm?.get('reportId')?.value ?? this.formData?.reportId ?? this.reportConfig?.id;
    if (reportId != null) {
      const moduleInfo = this.getModuleInfo(Number(reportId));
      if (moduleInfo?.parentId !== undefined && moduleInfo.parentId !== null && moduleInfo.parentId !== 0) {
        return true;
      }
    }
    return false;
  }

  /** Save as New: user-saved, admin, or child report (with add permission). */
  showSaveAsNewReportButton(): boolean {
    if (!this.checkAddReportPermission()) {
      return false;
    }
    return this.disableSaveReportButton() || this.isAdminReport() || this.isChildReport();
  }

  /** Create Save Report: new/unsaved only; hidden for admin/child (use Save as New instead). */
  showCreateSaveReportButton(): boolean {
    if (!this.checkAddReportPermission()) {
      return false;
    }
    if (this.isAdminReport() || this.isChildReport()) {
      return false;
    }
    return !this.isReportAlreadySaved();
  }

  /**
   * @description Report Level Security 
   * @author: Pavan Kumar 
   */

  getUserListData() {
    this._commonHttpService.getUserList(this.savedReportData.savedReports[0].id).subscribe((data: any) => {
    });
  }

  loadRolesAndTeamsData(): void {
    /*
    const reportFrom = this.savedReportData.savedReports[0].reportFrom == 2 ? this.savedReportData.savedReports[0].id : this.savedReportData.savedReports[0].reportId;*/
    /* let reportId = 0;
    let reportFrom = 1;
    let isChildReport = false;
    if (Object.keys(this.savedReportData).length === 0) {
      reportId = this.formData.reportId;
      reportFrom = 1;
      if (this.reportConfig.parentId !== 0 && this.reportConfig.parentId !== null) {
        isChildReport = true;
      }
    } else {
      reportId = this.savedReportData.savedReports[0].id;
      reportFrom = 2;
    }
    */
    let data: any = {};
    // if (!isChildReport) {
    if (Object.keys(this.savedReportData).length === 0) {
      data = {};
    } else if (this.savedReportData.savedReports[0].isAdminReport == 0) {
      data = { reportId: this.savedReportData.savedReports[0].id, reportFrom: 2 };
    }
    this.spinnerService.withSpinner(
      this._commonHttpService.getUserList(data),
      'Loading report security'
    ).subscribe((data: any) => {
      if (data) {
        this.reportSecurity = data.data.reportLevelSecurity;
        // Extract roles
        if (data.data.roleList && Array.isArray(data.data.roleList)) {
          this.roleList = data.data.roleList;
        }
        if (data.data.teamMembers && data.data.teamMembers.teamNames && Array.isArray(data.data.teamMembers.teamNames)) {
          this.teamList = data.data.teamMembers.teamNames;
        }
        this.getEditRoleAndTeamList(data.data.reportLevelSecurity);
        if (data.data.reportLevelSecurity) {
          this.isUpdated = true;
        }
        if (data.data.reportLevelSecurity) {
          // Patch the form controls with the valid role and team codes
          const reportLevelSecurity = data.data.reportLevelSecurity;
          const securityPatch: any = {
            viewRoleIds: this.filterNullValues(reportLevelSecurity.viewRoleIds || []),
            viewTeamIds: this.filterNullValues(reportLevelSecurity.viewTeamIds || []),
            editRoleIds: this.filterNullValues(reportLevelSecurity.editRoleIds || []),
            editTeamIds: this.filterNullValues(reportLevelSecurity.editTeamIds || []),
            viewToAll: reportLevelSecurity.viewToAll,
            // editToAll: reportLevelSecurity.editToAll,
          };
          if (reportLevelSecurity.enableHierarchySecurity !== undefined && reportLevelSecurity.enableHierarchySecurity !== null) {
            securityPatch.enableHierarchySecurity = Number(reportLevelSecurity.enableHierarchySecurity) === 1
              || reportLevelSecurity.enableHierarchySecurity === true;
          }
          this.reportForm.patchValue(securityPatch);


          if (data.data.reportLevelSecurity.editToAll) {
            this.reportForm.get('editToAll')?.setValue(data.data.reportLevelSecurity.editToAll);
            this.reportForm.get('editToAll')?.enable();
          } else {
            // this.reportForm.get('editToAll')?.setValue(data.data.reportLevelSecurity.editToAll);
            this.reportForm.get('editToAll')?.disable();
          }



        }

        let viewRoleIds = this.reportForm.get('viewRoleIds')?.value || [];
        let viewTeamIds = this.reportForm.get('viewTeamIds')?.value || [];
        let editRoleIds = this.reportForm.get('editRoleIds')?.value || [];
        let editTeamIds = this.reportForm.get('editTeamIds')?.value || [];

        // View all access
        this.viewAccessCondition = (viewRoleIds.length === 0 || ((viewRoleIds[0] === 0 || viewRoleIds[0] === '0'))) && (viewTeamIds.length === 0 || ((viewTeamIds[0] === 0 || viewTeamIds[0] === '0'))) && data.data.reportLevelSecurity != null && data.data.reportLevelSecurity?.reportId !== '';
        if (data.data.reportLevelSecurity.viewToAll) {
          this.reportForm.get('viewRoleIds')?.setValue([]);
          this.reportForm.get('viewTeamIds')?.setValue([]);
          this.viewAllAccess = true;
          this.RoleDisabledOpt = true;
          this.editAllAccess = false;
          this.checked = false;
        } else {
          this.viewAllAccess = false;
          this.RoleDisabledOpt = false;
          /* this.editRoleList = this.roleList;
          this.editTeamList = this.teamList;
          this.editAllAccess = false; */
        }

        // Edit all access
        if (/**(editRoleIds.length === 0 || ((editRoleIds[0] === 0 || editRoleIds[0] === '0'))) && (editTeamIds.length === 0 || ((editTeamIds[0] === 0 || editTeamIds[0] === '0' || editTeamIds[0] === null))) && data.data.reportLevelSecurity != null && data.data.reportLevelSecurity?.reportId !== '' */ this.reportForm.get('editToAll')?.value) {
          this.editAllAccess = true;
          this.editRoleDisabled = true;

          this.reportForm.get('editRoleIds')?.setValue([]);
          this.reportForm.get('editTeamIds')?.setValue([]);
        } else {
          // this.editAllAccess = false;
          this.checked = false;
          this.editRoleDisabled = false;
          /*  this.editRoleList = this.roleList;
           this.editTeamList = this.teamList; */
        }

        this.changeeditAllAccess({ ev: { checked: false } })
        if (this.reportForm.get('viewToAll')?.value) {
          this.changeViewAllAccess({ checked: this.reportForm.get('viewToAll')?.value });
        }

        if (this.reportForm.get('editToAll')?.value) {
          this.changeeditAllAccess({ checked: this.reportForm.get('editToAll')?.value });
        }
        /*  this.changeViewAllAccess({checked: this.reportForm.get('viewToAll')?.value});
           this.changeeditAllAccess({checked: this.reportForm.get('editToAll')?.value}); */

        // Update form toggle values
        /* this.reportForm.patchValue({
          viewToAll: this.viewAllAccess,
          editToAll: this.editAllAccess
        }); */
      }
    },
    );
  }


  /* changeViewAllAccess(event: any) {
    this.viewAllAccess = event.checked;

    if (this.viewAllAccess) {
      this.editRoleList = this.roleList;
      this.editTeamList = this.teamList;
      this.RoleDisabledOpt = true;
      this.editAllAccess = false;
      this.editRoleDisabled = false;

      // Remove validators when view all access is enabled
      this.reportForm.get('viewRoleIds')?.clearValidators();
      this.reportForm.get('viewTeamIds')?.clearValidators();
    } else {
      if (this.isUpdated) {
        this.getEditRoleAndTeamList(this.reportSecurity);
      } else {
        this.editRoleList = []
        this.editTeamList = [];
      }
      this.RoleDisabledOpt = false;
      this.editAllAccess = false;
      this.editRoleDisabled = false;
      this.reportForm.get('editRoleIds')?.setValue([]);
      this.reportForm.get('editTeamIds')?.setValue([]);

      // Add back validators when view all access is disabled
      this.reportForm.get('viewRoleIds')?.setValidators(Validators.required);
      this.reportForm.get('viewTeamIds')?.clearValidators();
    }

    // Update validators
    this.reportForm.get('viewRoleIds')?.updateValueAndValidity();
    this.reportForm.get('viewTeamIds')?.updateValueAndValidity();

    // Update the form control value
    this.reportForm.patchValue({
      viewToAll: this.viewAllAccess
    });
  } */
  changeViewAllAccess(ev: any) {
    this.viewAllAccess = ev.checked;
    if (this.viewAllAccess) {
      this.editRoleList = this.roleList;
      this.editTeamList = this.teamList;
      this.RoleDisabledOpt = true;
      this.editAllAccess = false;
      this.editRoleDisabled = false;
      this.reportForm.get('viewRoleIds')?.setValue([]);
      this.reportForm.get('viewTeamIds')?.setValue([]);

      // Remove validators when viewAllAccess button is enabled
      this.reportForm.get('viewRoleIds')?.clearValidators();
      this.reportForm.get('viewRoleIds')?.updateValueAndValidity();

      // Enable the editToAll toggle switch
      this.reportForm.get('editToAll')?.enable();

    } else {
      if (this.isUpdated) {
        this.getEditRoleAndTeamList(this.reportSecurity);
      } else {
        this.editRoleList = []
        this.editTeamList = [];
      }
      this.RoleDisabledOpt = false;
      this.editAllAccess = false;
      this.editRoleDisabled = false;
      this.reportForm.get('editRoleIds')?.setValue([]);
      this.reportForm.get('editTeamIds')?.setValue([]);

      // if (this.isUpdated) {
      this.reportForm.get('viewRoleIds')?.setValue([]);
      this.reportForm.get('viewTeamIds')?.setValue([]);
      // }

      // Add back validators when viewAllAccess button is disabled
      this.reportForm.get('viewRoleIds')?.setValidators([Validators.required]);
      this.reportForm.get('viewRoleIds')?.updateValueAndValidity();

      // Disable the editToAll toggle switch
      this.reportForm.get('editToAll')?.setValue(false);
      this.reportForm.get('editToAll')?.disable();

    }
    // Update the form control value
    /*  this.reportForm.patchValue({
       viewToAll: this.viewAllAccess
     }); */
  }
  /* changeeditAllAccess(event: any) {
    this.editAllAccess = event.checked;
    if (this.editAllAccess) {
      this.editRoleDisabled = true;
      this.reportForm.get('editRoleIds')?.setValue([]);
      this.reportForm.get('editTeamIds')?.setValue([]);
    } else {
      // When edit all access is disabled, enable role and team selection
      this.editRoleDisabled = false;
      this.editRoleList = this.roleList;
      this.editTeamList = this.teamList;
    }
    // Update the form control value
    this.reportForm.patchValue({
      editToAll: this.editAllAccess
    });
  } */

  changeeditAllAccess(ev: any) {
    this.editAllAccess = ev.checked;
    if (this.editAllAccess) {
      this.editRoleDisabled = true;
      this.reportForm.get('editRoleIds')?.setValue([]);
      this.reportForm.get('editTeamIds')?.setValue([]);
    } else {
      // When edit all access is disabled, enable role and team selection
      this.editRoleDisabled = false;
      // this.editRoleList = this.roleList;
      // this.editTeamList = this.teamList;

    }
    // Update the form control value
    /* this.reportForm.patchValue({
      editToAll: this.editAllAccess
    }); */
  }

  /**Append selected roles to editRoleList */
  onRoleChange(event: any) {
    // Get current view role selections
    const viewRoleIds = this.filterNullValues(this.reportForm.get('viewRoleIds')?.value || []);
    const editRoleIds = this.filterNullValues(this.reportForm.get('editRoleIds')?.value || []);


    if (typeof event.itemValue != 'object' && Array.isArray(editRoleIds)) {
      const index = editRoleIds.indexOf(event.itemValue);
      if (index > -1) { // Only splice array when item is found
        editRoleIds.splice(index, 1);
      }
      this.reportForm.get('editRoleIds')?.setValue(editRoleIds);
    }

    // Update editRoleList to reflect the selected view roles
    this.editRoleList = this.roleList.filter((role: any) =>
      viewRoleIds.includes(role.code)
    );

  }
  
  /** @description Append selected team options to editTeamList */
  onTeamChange(event: any) {
    // Get current view team selections
    const viewTeamIds = this.filterNullValues(this.reportForm.get('viewTeamIds')?.value || []);
    const editTeamIds = this.filterNullValues(this.reportForm.get('editTeamIds')?.value || []);

    if (typeof event.itemValue != 'object' && Array.isArray(editTeamIds)) {
      const index = editTeamIds.indexOf(event.itemValue);
      if (index > -1) { // Only splice array when item is found
        editTeamIds.splice(index, 1);
      }
      this.reportForm.get('editTeamIds')?.setValue(editTeamIds);
    }

    // Update edit team form control to match view team selections
    /* this.reportForm.patchValue({
      editTeamIds: viewTeamIds
    }); */

    // Update editTeamList to reflect the selected view teams
    this.editTeamList = this.teamList.filter((team: any) =>
      viewTeamIds.includes(team.code)
    );
  }

  // closeDrawer() {
  //   this.visible2 = false;
  //   this._commonService.hideReportLevelSecurity();
  // }
  saveReportSecurity(): void {
    if (this.reportForm.valid) {
      const formData = this.reportForm.value;
      formData.reportId = this.savedReportData.savedReports[0].id;
      formData.reportFrom = 2;
      formData.viewRoleIds = this.reportSecurity.value.viewRoleIds;
      formData.viewTeamIds = this.reportSecurity.value.viewTeamIds;
      formData.editRoleIds = this.reportSecurity.value.editRoleIds;
      formData.editTeamIds = this.reportSecurity.value.editTeamIds;
      this.spinnerService.withSpinner(
        this._commonHttpService.saveReportSecurity(formData),
        'Saving report security'
      ).subscribe({
        next: (response: any) => {
          this._commonService.hideReportLevelSecurity();
        },
        error: (error) => {
        }
      });
    } else {
      this.markFormGroupTouched();
    }
  }

  // onCancel(): void {
  //   this.visible2 = false;
  //   this.reportSecurityForm.reset();
  //   this._commonService.hideReportLevelSecurity();
  // }

  getEditRoleAndTeamList(reportLevelSecurity: any) {
    if (!reportLevelSecurity) {
      this.editRoleList = [];
      this.editTeamList = [];
      return;
    }

    const viewRoleIds = this.filterNullValues(reportLevelSecurity.viewRoleIds || []);
    const viewTeamIds = this.filterNullValues(reportLevelSecurity.viewTeamIds || []);

    this.editRoleList = this.roleList.filter((role: any) => viewRoleIds.includes(role.code));
    this.editTeamList = this.teamList.filter((team: any) => viewTeamIds.includes(team.code));
  }

  markFormGroupTouched(): void {
    Object.keys(this.reportForm.controls).forEach(key => {
      const control = this.reportForm.get(key);
      control?.markAsTouched();
    });
  }

  /**
   * Helper method to filter out null and undefined values from arrays
   * @param arr - The array to filter
   * @returns Filtered array without null/undefined values
   */
  private filterNullValues(arr: any[]): any[] {
    return Array.isArray(arr) ? arr.filter(item => item !== null && item !== undefined && item !== '' && item !== 0) : [];
  }
  onCancel() {
    this.reportForm.reset();
    this.clearAllFilterMaxEndDates();
    // this.reportForm.patchValue({
    //   viewRoleIds: [],
    //   viewTeamIds: [],
    // });
    // this.editRoleList = [];
    // this.editTeamList = [];
    // this.RoleDisabledOpt = false;
    // this.editAllAccess = false;
    // this.editRoleDisabled = false;
    // this.viewAllAccess = false;
  }

  onStartDateSelect(event: any) {

    if (event && event instanceof Date) {
      // Create a new date object to avoid mutating the original
      const selectedDate = new Date(event);

      // Add one year to the selected date for the max end date
      const maxEndDate = new Date(selectedDate);
      maxEndDate.setFullYear(maxEndDate.getFullYear() + 1);

      // Set this date as the max date for the end date picker
      this.maxEndDate = maxEndDate;

      // Update the form control with the original selected date (not the +1 year date)
      this.reportForm.get('custStartDate')?.setValue(selectedDate);

    }
  }

  /**
   * Handles start date selection for filter date ranges
   * @param event - The selected date event
   * @param filterIndex - The index of the filter in the form array
   */
  onFilterStartDateSelect(event: any, filterIndex: number) {
    if (event && event instanceof Date) {
      // Create a new date object to avoid mutating the original
      const selectedDate = new Date(event);

      // Add one year to the selected date for the max end date
      const maxEndDate = new Date(selectedDate);
      maxEndDate.setFullYear(maxEndDate.getFullYear() + 1);

      // Store both min and max end dates for this specific filter
      this.filterMaxEndDates[filterIndex] = maxEndDate;
      this.filterMinEndDates[filterIndex] = selectedDate;

      // Clear the end date if it's before the new start date
      const currentEndDate = this.filtersFormArray.at(filterIndex).get('endDate')?.value;
      if (currentEndDate && currentEndDate < selectedDate) {
        this.filtersFormArray.at(filterIndex).get('endDate')?.setValue(null);
      }
    } else if (event === null || event === undefined) {
      // If start date is cleared, also clear the min/max end dates
      delete this.filterMaxEndDates[filterIndex];
      delete this.filterMinEndDates[filterIndex];
    }
  }

  /**
   * Gets the maximum end date for a specific filter
   * @param filterIndex - The index of the filter
   * @returns The maximum end date or null
   */
  getFilterMaxEndDate(filterIndex: number): Date | null {
    return this.filterMaxEndDates[filterIndex] || null;
  }

  /**
   * Gets the minimum end date for a specific filter
   * @param filterIndex - The index of the filter
   * @returns The minimum end date or null
   */
  getFilterMinEndDate(filterIndex: number): Date | null {
    return this.filterMinEndDates[filterIndex] || null;
  }

  /**
   * Clears all filter max and min end dates
   */
  clearAllFilterMaxEndDates(): void {
    this.filterMaxEndDates = {};
    this.filterMinEndDates = {};
  }

  checkMarketTypeDisplay(): boolean {
    return !(this.reportForm.get('reportId')?.value == '20' && this.globalBusinessUnitList.length > 0 && this.indiaBusinessUnitList.length > 0);
  }
  checkAddReportPermission(): boolean {
    if (!this.reportConfig || !this.reportConfig.reportModuleSecurity) {
      return false;
    }
    return (this.reportConfig.reportModuleSecurity.addPermission == 1 || this.reportConfig.reportModuleSecurity.fullAccess == 1);
  }

  checkUpdateReportPermission(): boolean {
    if (!this.reportConfig || !this.reportConfig.reportModuleSecurity || !this.savedReportData?.savedReports?.[0]) {
      return false;
    }
    return ((this.reportConfig.reportModuleSecurity.editPermission == 1 && this.savedReportData.savedReports[0].editAccess) || this.reportConfig.reportModuleSecurity.fullAccess == 1);
  }
}
